import React, { useEffect, useRef, useState, useMemo, useCallback } from 'react';
import { toast, ToastContainer } from 'react-toastify';
import Phaser from 'phaser';
import grassXImage from './assets/grassX.png';
import foodXImage from './assets/foodX.png';
import woodXImage from './assets/woodX.png';
import stoneXImage from './assets/stoneX.png';
import ironXImage from './assets/ironX.png';
import eldersImage from './assets/elders.png';
import armoryImage from './assets/buildings/armory.png';
import blacksmithImage from './assets/buildings/blacksmith.png';
import clanhallImage from './assets/buildings/clanhall.png';
import fightingpitImage from './assets/buildings/fightingpit.png';
import houseImage from './assets/buildings/house.png';
import marketImage from './assets/buildings/market.png';
import towerImage from './assets/buildings/tower.png';
import workshopImage from './assets/buildings/workshop.png';
import backgroundMusicFile from './assets/background2.mp3';

import armorySound from './assets/armory.mp3';
import turnSound from './assets/turnuse.mp3';
import constructionSound from './assets/construction.mp3';
import clancreateSound from './assets/clancreate.mp3';
import trainingSound from './assets/training.mp3';
import upgradeSound from './assets/upgrade.mp3';

import foodImage from './assets/res/food.png';
import woodImage from './assets/res/wood.png';
import stoneImage from './assets/res/stone.png';
import ironImage from './assets/res/iron.png';
import turnsImage from './assets/res/turns.png';
import playIcon from './assets/play-icon.png';
import stopIcon from './assets/stop-icon.png';

import clockLoadingImage from './assets/clock-loading.gif';
import forgekLoadingImage from './assets/forge-loading.gif';
import offensiveLoadingImage from './assets/training-offsenvie.gif';
import defensiveLoadingImage from './assets/training-defensive.gif';
import clancreateLoadingImage from './assets/clan-creating.gif';

import offensiveTechLoadingImage from './assets/offensiveTech-loading.gif';
import defensiveTechLoadingImage from './assets/defensiveTech-loading.gif';

import defensiveArmorImage from './assets/armors/defensive.png';
import offensiveArmorImage from './assets/armors/offensive.png';

import defensiveWeaponImage from './assets/weapons/defensive.png';
import offensiveWeaponImage from './assets/weapons/offensive.png';

import defensiveSoldierImage from './assets/soldiers/defensive.png';
import offensiveSoldierImage from './assets/soldiers/offensive.png';

import getTheLandContract, { getTheLandSignerContract  } from './TheLandContract';
import { getMarketplaceSignerContract, MarketplacecontractAddress } from './MarketplaceContract';
import { getclanSignerContract, clancontractAddress } from './clancontract';
import { getTokenSignerContract } from './Tokencontract';
import { getNFTSignerContract } from './nftContract';

import { Circles } from 'react-loader-spinner';
import './App.css';
import getContract from './contract';

const TheLand = ({ tileCoords, goBackToApp }) => {
    const gameRef = useRef(null);
    const selectedBuildingRef = useRef(null);
    const [metaMaskAccount, setMetaMaskAccount] = useState(null); // Kept for loginMetaMask logic
    const [isMetaMaskConnected, setIsMetaMaskConnected] = useState(false); // Kept for MetaMask state tracking
    const [selectedBuilding, setSelectedBuilding] = useState(null);
    const [interactionMenuType, setinteractionMenuType] = useState("home");
    const buildingPreviewRef = useRef(null);
    const [loading, setLoading] = useState(true); // New state for loading
    const [loadingTurns, setLoadingTurns] = useState(false);
    const [loadingArmoryForge, setloadingArmoryForge] = useState(false);
    const [loadingBlacksmithForge, setloadingBlacksmithForge] = useState(false);
    const [loadingOffensiveTraining, setloadingOffensiveTraining] = useState(false);
    const [loadingDefensiveTraining, setloadingDefensiveTraining] = useState(false);
    const [loadingClanCreate, setloadingClanCreate] = useState(false);
    const [laodingOffensiveTech, setlaodingOffensiveTech] = useState(false);
    const [loadingDefensiveTech, setloadingDefensiveTech] = useState(false);
    
    const [tileData, setTileData] = useState(null); // For storing tile data (food, wood, stone, iron, level)
    const mapSize = 9;
    const turnsPerLevel = 1000;
    const clancreationcost = 100000 * 10 ** 6;
    const [armorQuantities, setArmorQuantities] = useState({ offensive: 0, defensive: 0 }); // To track input quantities
    const [weaponQuantities, setWeaponQuantities] = useState({ offensive: 0, defensive: 0 }); // To track input quantities
    const [soldierQuantities, setSoldierQuantities] = useState({ offensive: 0, defensive: 0 });

    const [showArmorCosts, setShowArmorCosts] = useState(false);
    const [showWeaponCosts, setShowWeaponCosts] = useState(false);
    const [showSoldierCosts, setShowSoldierCosts] = useState(false);
    const [buildingCounts, setBuildingCounts] = useState({});
    const [newClanName, setNewClanName] = useState('');

    const [selectedResourceType, setSelectedResourceType] = useState("1"); // Default to Food
    const [marketplaceItems, setMarketplaceItems] = useState([]);

    const [selectedResource, setSelectedResource] = useState("1");
const [sellAmount, setSellAmount] = useState("");
const [sellPrice, setSellPrice] = useState("");

const [userClan, setUserClan] = useState(null);
const [clanDetails, setClanDetails] = useState(null);


const [allClans, setAllClans] = useState([]);
const [showAllClansModal, setShowAllClansModal] = useState(false);

const [pendingInviteClanId, setPendingInviteClanId] = useState(null);
const [pendingInviteClanName, setPendingInviteClanName] = useState("");


const [showNameInput, setShowNameInput] = useState(false);
const [tileNameInput, setTileNameInput] = useState('');

const [tileName, setTileName] = useState('');

const [showFlagSelector, setShowFlagSelector] = useState(false);
const [ownedFlagNFTs, setOwnedFlagNFTs] = useState([]);

const musicRef2 = useRef(null);
const [isMusicPlaying, setIsMusicPlaying] = useState(false);
const [defenderCooldownTurnsLeft, setDefenderCooldownTurnsLeft] = useState(null);
const [selectedInteriorCoords, setSelectedInteriorCoords] = useState(null);

const [ResourceReceivedMessage, setResourceReceivedMessage] = useState('');
const [ResourceReceived, setResourceReceived] = useState(false);


const [musicOnce, setmusicOnce] = useState(false);
    const [armorCosts, setArmorCosts] = useState({
        food: 0,
        wood: 0,
        stone: 0,
        iron: 0,
    });

    const [weaponCosts, setWeaponCosts] = useState({
        food: 0,
        wood: 0,
        stone: 0,
        iron: 0,
    });

    const [soldierCosts, setSoldierCosts] = useState({
        food: 0,
        wood: 0,
        stone: 0,
        iron: 0,
    });
    
    

    const buildingTypes = [
    { key: 'armory', no: 1, label: 'Armory', image: 'armory', cost: { wood: 3200, stone: 1440, food: 1240, iron: 880 } },
    { key: 'blacksmith', no: 2, label: 'Blacksmith', image: 'blacksmith', cost: { wood: 3000, stone: 1300, food: 1300, iron: 900 } },
    { key: 'clanhall', no: 3, label: 'Clan Hall', image: 'clanhall', cost: { wood: 4200, stone: 1960, food: 1760, iron: 1320 } },
    { key: 'fightingpit', no: 4, label: 'Fighting Pit', image: 'fightingpit', cost: { wood: 2800, stone: 1240, food: 1240, iron: 940 } },
    { key: 'house', no: 5, label: 'House', image: 'house', cost: { wood: 1040, stone: 450, food: 400, iron: 230 } }, // unchanged
    { key: 'market', no: 6, label: 'Market', image: 'market', cost: { wood: 3120, stone: 1460, food: 1460, iron: 880 } },
    { key: 'tower', no: 7, label: 'Tower', image: 'tower', cost: { wood: 6400, stone: 12200, food: 2780, iron: 2340 } },
    { key: 'workshop', no: 8, label: 'Workshop', image: 'workshop', cost: { wood: 3680, stone: 1880, food: 1680, iron: 1360 } },
];



    


  const buildingImageMap = useMemo(() => ({
    1: 'armory',
    2: 'blacksmith',
    3: 'clanhall',
    4: 'fightingpit',
    5: 'house',
    6: 'market',
    7: 'tower',
    8: 'workshop',
}), []);

const [calculatedResources, setCalculatedResources] = useState({
    food: 0,
    wood: 0,
    stone: 0,
    iron: 0,
});


// --- context open helper: right-click OR double-tap ---
const DOUBLE_TAP_MS = 320;
const DOUBLE_TAP_MOVE_PX = 24;








function makeContextOpener(displayObj, onOpen) {
  let lastTapTime = 0;
  let lastTapX = 0;
  let lastTapY = 0;

  displayObj.setInteractive({ pixelPerfect: true });

  displayObj.on('pointerdown', (pointer) => {
    // Desktop right-click -> open immediately
    if (pointer.button === 2) {
      onOpen();
      return;
    }

    // Touch / left-click: detect double-tap
    // (Phaser sets pointer.primaryDown for primary button/finger)
    const now = performance.now();
    const dx = pointer.x - lastTapX;
    const dy = pointer.y - lastTapY;
    const dist2 = dx * dx + dy * dy;

    if (now - lastTapTime <= DOUBLE_TAP_MS && dist2 <= DOUBLE_TAP_MOVE_PX * DOUBLE_TAP_MOVE_PX) {
      // second tap within window and close to first tap -> act like right-click
      onOpen();
      // reset so triple taps don't chain
      lastTapTime = 0;
    } else {
      // record this tap
      lastTapTime = now;
      lastTapX = pointer.x;
      lastTapY = pointer.y;
    }
  });
}





const cancelListing = async (item, index) => {
  try {
    setLoading(true);

    const TokenContract = await getTokenSignerContract();
        const approvalTx = await TokenContract.increaseAllowance(MarketplacecontractAddress, 10000 * 10 ** 6);
        await approvalTx.wait();


    const contract = await getMarketplaceSignerContract();
    const tx = await contract.cancelListing(
      item.sellerX - 1,
      item.sellerY - 1,
      item.resourceType,
      index
    );
    await tx.wait();

    toast.success("Listing canceled.");
    await fetchTileData(tileCoords.x, tileCoords.y);
    await fetchMarketplaceItemsByType();
  } catch (error) {
    console.error("Error canceling listing:", error);
    toast.error("Failed to cancel listing.");
  } finally {
    setLoading(false);
  }
};




const demolishBuilding = async (interiorX, interiorY) => {
  try {
    setLoading(true);
    const contract = await getTheLandSignerContract();
    const tx = await contract.demolishBuilding(
      tileCoords.x - 1,
      tileCoords.y - 1,
      interiorX,
      interiorY
    );
    await tx.wait();
    toast.success(`Building at (${interiorX}, ${interiorY}) demolished successfully!`);

    // Fetch updated tile data after the building is placed
            await fetchTileData(tileCoords.x, tileCoords.y);
            setArmorQuantities({ offensive: 0, defensive: 0 });
setWeaponQuantities({ offensive: 0, defensive: 0 });
setSoldierQuantities({ offensive: 0, defensive: 0 });
setArmorCosts({ food: 0, wood: 0, stone: 0, iron: 0 });
setWeaponCosts({ food: 0, wood: 0, stone: 0, iron: 0 });
setSoldierCosts({ food: 0, wood: 0, stone: 0, iron: 0 });
setShowArmorCosts(false);
setWeaponCosts(false);
setSoldierCosts(false);


            const updatedBuildings = await fetchAllBuildings(tileCoords.x - 1, tileCoords.y - 1);

const updatedCounts = {};
updatedBuildings.forEach((row) => {
    row.forEach((type) => {
        if (type > 0) {
            updatedCounts[type] = (updatedCounts[type] || 0) + 1;
        }
    });
});
setBuildingCounts(updatedCounts);


if (gameRef.current && gameRef.current.scene && gameRef.current.scene.keys && gameRef.current.scene.keys.default) {
  const scene = gameRef.current.scene.keys.default;
  const sprite = scene.buildingSprites?.[interiorX]?.[interiorY];
  if (sprite) {
    sprite.destroy();
    scene.buildingSprites[interiorX][interiorY] = null;
  }
}



const overlayGroups = [
      "houseClockOverlays",
      "trainingOffensiveOverlays",
      "trainingDefensiveOverlays",
      "armoryForgeOverlays",
      "blacksmithForgeOverlays",
      "offensiveTechOverlays",
      "defensiveTechOverlays",
      "flagOverlays"
    ];

    overlayGroups.forEach((group) => {
      let overlays = gameRef.current[group];
      if (!overlays) return;

      if (Array.isArray(overlays)) {
        // remove overlays matching (x, y)
        gameRef.current[group] = overlays.filter(({ x: ox, y: oy, overlay }) => {
          if (ox === interiorX && oy === interiorY) {
            overlay.destroy(); // destroy DOM element
            return false; // remove from array
          }
          return true;
        });
      }
    });




    // 3. Reset interaction menu
    setinteractionMenuType('home');




  } catch (error) {
    console.error("Failed to demolish building:", error);
    toast.error("Failed to demolish building.");
  } finally {
    setLoading(false);
  }
};





useEffect(() => {
  if (window.ethereum) {
    const handleAccountsChanged = (accounts) => {
      if (accounts.length === 0) return;
      if (accounts[0] !== metaMaskAccount) {
        window.location.reload(); // 👈 Same effect as your "Back to Map" button
      }
    };

    window.ethereum.on("accountsChanged", handleAccountsChanged);

    return () => {
      window.ethereum.removeListener("accountsChanged", handleAccountsChanged);
    };
  }
}, [metaMaskAccount]);




const fetchDefenderCooldown = useCallback(async (x, y) => {
  try {
    const marketContract = await getMarketplaceSignerContract();
    const landContract = await getTheLandSignerContract();

    const defTurnsUsedRaw = await landContract.getTotalTurnsUsedByTile(x - 1, y - 1);
    const defTurnsUsed = parseInt(defTurnsUsedRaw.toString());

    const lastDefRaw = await marketContract.lastDefenseTurn(x - 1, y - 1);
    const lastDef = parseInt(lastDefRaw.toString());

    const cooldownEnd = lastDef + 300;
    const turnsLeft = Math.max(0, cooldownEnd - defTurnsUsed);

    setDefenderCooldownTurnsLeft(turnsLeft);
  } catch (error) {
    console.error("Error fetching defender cooldown:", error);
    setDefenderCooldownTurnsLeft(null);
  }
}, []);

useEffect(() => {
  if (tileCoords?.x != null && tileCoords?.y != null) {
    fetchDefenderCooldown(tileCoords.x, tileCoords.y);
  }
}, [tileCoords?.x, tileCoords?.y, fetchDefenderCooldown]);



// helper: keep your existing checks here
const handleSelectBuilding = (building) => {
  if (building.key === "clanhall" && (buildingCounts[3] || 0) >= 1) {
    toast.error("Clanhall Limit ( Max:1 )");
    return;
  }
  if (building.key === "market" && (buildingCounts[6] || 0) >= 1) {
    toast.error("Market Limit ( Max:1 )");
    return;
  }
  setSelectedBuilding(building.image);
};



const handleSetClanFlag = async (tokenId) => {

  try {
    if (!userClan) {
      toast.error("Join or create a clan first.");
      return;
    }
    if (!clanDetails?.isLeader) {
      toast.error("Only the clan leader can set the flag.");
      return;
    }

    setLoading(true);
    gameRef.current?.sounds?.clancreate?.play?.();

    const clan = await getclanSignerContract();
    const land = await getTheLandContract();

    // Get leader tile coords from on-chain info
    const info = await clan.getClanInfo(userClan);
    const leaderX = parseInt(info.leaderX);
    const leaderY = parseInt(info.leaderY);

    // Must have a Clan Hall at the leader tile
    const hasHall = await land.hasClanHallAtCoord(leaderX, leaderY);
    if (!hasHall) {
      toast.error("You need a Clan Hall at your leader tile to set a flag.");
      setLoading(false);
      return;
    }

    // Approve 10,000 LOP (10,000 * 10^6)
    const token = await getTokenSignerContract();
    const approvalTx = await token.increaseAllowance(
      clancontractAddress,
      10_000 * 10 ** 6
    );
    await approvalTx.wait();

    // Set flag with leader coords
    const tx = await clan.setClanFlag(userClan, leaderX, leaderY, tokenId);
    await tx.wait();

    toast.success("Clan flag set!");
    setShowFlagSelector(false);
  } catch (err) {
    console.error("Failed to set clan flag", err);
    toast.error("Failed to set flag");
  } finally {
    setLoading(false);
  }
};



useEffect(() => {
  const tryPlayMusic2 = (e) => {
    if (musicRef2.current && !isMusicPlaying) {
      try {
        musicRef2.current.play();
        setIsMusicPlaying(true);
      } catch (err) {
        console.warn("Music autoplay failed", err);
      }
    }

    // Remove listeners after first interaction
    document.removeEventListener('pointerdown', tryPlayMusic2);
  };

  if (!musicOnce) {
  document.addEventListener('pointerdown', tryPlayMusic2);
  setmusicOnce(true);
  }

  

}, [isMusicPlaying, musicOnce]);


const fetchFlagNFTs = async () => {
  try {
    const nftContract = await getNFTSignerContract(); // MyNFTMarket
    const tokenIds = await nftContract.getOwnedTokenIds(metaMaskAccount);
    
    const validFlagNFTs = [];
    for (let i = 0; i < tokenIds.length; i++) {
      const tid = tokenIds[i];
      const [, , url, , , , , , , cId, ] = await nftContract.getNFTData(tid);
      if (Number(cId) === 1) {
        validFlagNFTs.push({ tokenId: tid, imageUrl: url });
      }
    }

    setOwnedFlagNFTs(validFlagNFTs);
    setShowFlagSelector(true);
  } catch (err) {
    console.error("Failed to fetch flag NFTs", err);
    toast.error("Error getting NFTs from Kilopi NFT Market Collection id 1");
  }
};



const fetchTileNameX = async () => {
        try {
            const contract = await getclanSignerContract();
            const name = await contract.getTileName(tileCoords.x - 1, tileCoords.y - 1);
            setTileName(name);
        } catch (error) {
            console.error("Error fetching tile name:", error);
        }
    };




useEffect(() => {
    const fetchTileName = async () => {
        try {
            const contract = await getclanSignerContract();
            const name = await contract.getTileName(tileCoords.x - 1, tileCoords.y - 1);
            setTileName(name);
        } catch (error) {
            console.error("Error fetching tile name:", error);
        }
    };

    if (tileCoords?.x !== null && tileCoords?.y !== null) {
        fetchTileName();
    }
}, [tileCoords]);




const handleNameTile = async () => {
    if (!tileNameInput.trim()) {
        toast.error("Tile name cannot be empty.");
        return;
    }

    try {
        setLoading(true);

        const TokenContract = await getTokenSignerContract();
        const approvalTx = await TokenContract.increaseAllowance(clancontractAddress, 10000 * 10 ** 6);
        await approvalTx.wait();

        const contract = await getclanSignerContract();
        const tx = await contract.nameTile(tileCoords.x - 1, tileCoords.y - 1, tileNameInput);
        await tx.wait();

        await fetchTileNameX();

        toast.success("Realm named successfully!");
        setShowNameInput(false);
        setTileNameInput('');
    } catch (error) {
        console.error("Error naming tile:", error);
        toast.error("Failed to name tile.");
    } finally {
        setLoading(false);
    }
};




const fetchAllClans = async () => {
    try {
        const contract = await getclanSignerContract();
        const clans = await contract.getAllClans();
        setAllClans(clans);
        setShowAllClansModal(true);
    } catch (error) {
        console.error("Error fetching all clans:", error);
        toast.error("Failed to load all clans.");
    }
};


const fetchPendingInvite = useCallback(async () => {
    try {
    const clan = await getclanSignerContract();
    const tileMap = await getContract();

    const accounts = await window.ethereum.request({ method: 'eth_accounts' });
    const account = accounts && accounts[0] ? accounts[0] : null;
    if (!account) {
      setPendingInviteClanId(null);
      setPendingInviteClanName("");
      return;
    }



    const x = tileCoords.x - 1;
    const y = tileCoords.y - 1;

    // Verify ownership of that tile
    const occupant = await tileMap.getTileOccupant(x, y);
    if (!occupant || occupant.toLowerCase() !== account.toLowerCase()) {
      setPendingInviteClanId(null);
      setPendingInviteClanName("");
      return;
    }

    // Compute tile key: (x<<8)|y  ==> use multiply to avoid bitwise sign quirks
    const tileKey = x * 256 + y;

    // Read pending invite by tile
    const clanIdRaw = await clan.pendingInvitesByTile(tileKey);
    const clanId = parseInt(clanIdRaw);

    if (clanId > 0) {
      setPendingInviteClanId(clanId);
      const info = await clan.getClanInfo(clanId);
      setPendingInviteClanName(info.name);
    } else {
      setPendingInviteClanId(null);
      setPendingInviteClanName("");
    }
  } catch (error) {
    console.error("Error fetching pending invite:", error);
    setPendingInviteClanId(null);
    setPendingInviteClanName("");
  }
}, [tileCoords.x, tileCoords.y]);

const fetchResourceMessage = useCallback(async () => {
    try {
        const landContract = await getTheLandSignerContract();
        const messageX = await landContract.resourceMessage(tileCoords.x - 1, tileCoords.y - 1);

        if (messageX) {
            const marketContract = await getMarketplaceSignerContract();
            const messageC = await marketContract.getMyResourceMessage(tileCoords.x - 1, tileCoords.y - 1);
            const fromx = (parseInt(messageC.fromX) + 1).toString();
            const fromy = (parseInt(messageC.fromY) + 1).toString();
            const resourcetype = (messageC.resourceType).toString();
            const amount = (messageC.amount).toString();

            let resourceT = "";

            switch (resourcetype) {
        case "1":
            resourceT = "Food";
            break;
        case "2":
            resourceT = "Wood";
            break;
        case "3":
            resourceT = "Stone";
            break;
        case "4":
            resourceT = "Iron";
            break;
            case "5":
            resourceT = "Offensive Armor";
            break;
        case "6":
            resourceT = "Defensive Armor";
            break;
        case "7":
            resourceT = "Offensive Weapon";
            break;
        case "8":
            resourceT = "Defensive Weapon";
            break;
        default:
            break;
    }


            const message = `Received ${amount} ${resourceT} from ${fromx},${fromy}`;
            setResourceReceivedMessage(message);
            setResourceReceived(true);

        }

   
    } catch (error) {
        console.error("Error fetching resource receive:", error);
    }
}, [tileCoords.x, tileCoords.y]);


useEffect(() => {
    if (metaMaskAccount) {
        fetchPendingInvite();
        fetchResourceMessage();
    }
}, [metaMaskAccount, fetchResourceMessage, fetchPendingInvite]);

const checkUserClan = useCallback(async () => {
    try {
    const clan = await getclanSignerContract();
    const tileMap = await getContract();

    const accounts = await window.ethereum.request({ method: 'eth_accounts' });
    const account = accounts && accounts[0] ? accounts[0] : null;

    if (!account) {
      setUserClan(null);
      setClanDetails(null);
      return;
    }

    const x = tileCoords.x - 1;
    const y = tileCoords.y - 1;

    // Double-check ownership
    const occupant = await tileMap.getTileOccupant(x, y);
    if (!occupant || occupant.toLowerCase() !== account.toLowerCase()) {
      setUserClan(null);
      setClanDetails(null);
      return;
    }

    // Clan by tile
    const clanIdRaw = await clan.getTileClan(x, y);
    const clanId = parseInt(clanIdRaw);

    if (clanId > 0) {
      setUserClan(clanId);

      const info = await clan.getClanInfo(clanId);
      const details = {
        name: info.name,
        leaderX: parseInt(info.leaderX) + 1,
        leaderY: parseInt(info.leaderY) + 1,
        memberCount: parseInt(info.memberCount),
        exists: info.exists,
        isLeader: parseInt(info.leaderX) === x && parseInt(info.leaderY) === y,
      };

      setClanDetails(details);
    } else {
      setUserClan(null);
      setClanDetails(null);
    }
  } catch (error) {
    console.error("Error fetching clan info:", error);
    toast.error("Failed to fetch clan information.");
    setUserClan(null);
    setClanDetails(null);
  }
}, [tileCoords.x, tileCoords.y]);




const createClan = async () => {
  if (!newClanName || newClanName.trim() === "") {
    toast.error("Please enter a clan name.");
    return;
  }

  try {
    const clan = await getclanSignerContract();
    const tileMap = await getContract();

    // Check name availability first
    const available = await clan.isClanNameAvailable(newClanName);
    if (!available) {
      toast.error("This clan name is already taken.");
      return;
    }

    // Ensure wallet & find user's tile coords
    const accounts = await window.ethereum.request({ method: 'eth_accounts' });
    const account = accounts && accounts[0] ? accounts[0] : null;
    if (!account) {
      toast.error("Connect your wallet first.");
      return;
    }

    const x = tileCoords.x - 1;
    const y = tileCoords.y - 1;

    // Verify ownership of (x,y)
    const occupant = await tileMap.getTileOccupant(x, y);
    if (!occupant || occupant.toLowerCase() !== account.toLowerCase()) {
      toast.error("You must own a tile to create a clan.");
      return;
    }

    setloadingClanCreate(true);
    gameRef.current?.sounds?.clancreate?.play?.();

    // Approve/increase allowance for creation cost
    const token = await getTokenSignerContract();
    const allowanceTx = await token.increaseAllowance(
      clancontractAddress,
      clancreationcost
    );
    await allowanceTx.wait();

    // Create clan with tile coords + name
    const tx = await clan.createClan(x, y, newClanName.trim());
    await tx.wait();

    toast.success("Clan created successfully!");
    await checkUserClan();
    setNewClanName(""); // Reset input
  } catch (error) {
    console.error("Error creating clan:", error);
    toast.error("Failed to create clan.");
  } finally {
    setloadingClanCreate(false);
  }
};





const handleDisbandClan = async () => {
  // If you store just the id, rename to userClanId; if it's an object, adapt accordingly.
  const clanId = parseInt(userClan);
  if (!clanId) return;

  try {
    setLoading(true);

    const clanContract = await getclanSignerContract();

    // getClanInfo returns: { name, leaderX, leaderY, memberCount, exists }
    // ethers v5/v6 both also allow tuple indexing; we guard for both.
    const info = await clanContract.getClanInfo(clanId);
    const leaderX = info.leaderX ?? info[1];
    const leaderY = info.leaderY ?? info[2];


    if (
      parseInt(tileCoords.x) - 1 !== parseInt(leaderX) ||
      parseInt(tileCoords.y) - 1 !== parseInt(leaderY)
    ) {
      toast.error("Only the leader tile can disband the clan.");
      return;
    }

    // Call requires (clanId, lx, ly)
    const tx = await clanContract.disbandClan(clanId, leaderX, leaderY);
    await tx.wait();

    toast.success("Clan disbanded successfully!");
    await checkUserClan(); // refresh local UI/state
  } catch (error) {
    toast.info("Error disbanding clan:", error);

  } finally {
    setLoading(false);
  }
};






useEffect(() => {
    checkUserClan();
}, [checkUserClan]);




const produceArmor = async (armorType, quantity) => {
    if (quantity <= 0) {
        toast.error("Quantity must be greater than 0.");
        return;
    }

    try {
        setloadingArmoryForge(true);
        gameRef.current.sounds.armory.play();
        const contract = await getTheLandSignerContract();
        const tx = await contract.produceArmor(
            tileCoords.x - 1,
            tileCoords.y - 1,
            armorType,
            quantity
        );
        await tx.wait();
        toast.success(`${armorType === 1 ? "Offensive" : "Defensive"} armor produced successfully!`);
        await fetchTileData(tileCoords.x, tileCoords.y); // Refresh tile data
    } catch (error) {
        
        console.error("Error producing armor:", error);
        toast.error("Failed to produce armor. Please try again.");
    } finally {
        setloadingArmoryForge(false);
    }
};




const produceWeapon = async (weaponType, quantity) => {
    if (quantity <= 0) {
        toast.error("Quantity must be greater than 0.");
        return;
    }

    try {
        setloadingBlacksmithForge(true);
        gameRef.current.sounds.armory.play();
        const contract = await getTheLandSignerContract();
        const tx = await contract.produceWeapon(
            tileCoords.x - 1,
            tileCoords.y - 1,
            weaponType,
            quantity
        );
        await tx.wait();
        toast.success(`${weaponType === 1 ? "Offensive" : "Defensive"} weapon produced successfully!`);
        await fetchTileData(tileCoords.x, tileCoords.y); // Refresh tile data
    } catch (error) {
        console.error("Error producing weapon:", error);
        toast.error("Failed to produce weapon. Please try again.");
    } finally {
        setloadingBlacksmithForge(false);
    }
};



const trainSoldier = async (soldierType, quantity) => {
    if (quantity <= 0) {
        toast.error("Quantity must be greater than 0.");
        return;
    }

    try {

        if (soldierType === 1) {
        setloadingOffensiveTraining(true);
        gameRef.current.sounds.training.play();
        } else  if (soldierType === 2) {
        setloadingDefensiveTraining(true);
        gameRef.current.sounds.training.play();
        }

        const contract = await getTheLandSignerContract();
        const tx = await contract.createSoldier(
            tileCoords.x - 1,
            tileCoords.y - 1,
            soldierType,
            quantity
        );
        await tx.wait();
        toast.success(`${soldierType === 1 ? "Offensive" : "Defensive"} soldier trained successfully!`);
        
        await fetchTileData(tileCoords.x, tileCoords.y); // Refresh tile data after training soldiers
    } catch (error) {
        console.error("Error training soldier:", error);
        toast.error("Failed to train soldier. Please try again.");
    } finally {
        setloadingOffensiveTraining(false);
        setloadingDefensiveTraining(false);
    }
};


const upgradeTech = async (techType) => {
    try {

         if (techType === 1) {
        setlaodingOffensiveTech(true);
        gameRef.current.sounds.upgrade.play();
        } else  if (techType === 2) {
        setloadingDefensiveTech(true);
        gameRef.current.sounds.upgrade.play();
        }


        const contract = await getTheLandSignerContract();
        const tx = await contract.upgradeTech(tileCoords.x - 1, tileCoords.y - 1, techType);
        await tx.wait();
        toast.success("Technology upgraded successfully!");

        await fetchTileData(tileCoords.x, tileCoords.y); // Refresh data after upgrade
    } catch (error) {
        console.error("Error upgrading tech:", error);
        toast.error("Failed to upgrade technology. Please try again.");
    } finally {
        setlaodingOffensiveTech(false);
        setloadingDefensiveTech(false);
    }
};







const calculateArmorCost = useCallback((armorType, quantity) => {
    if (!tileData) return;

    const baseCost = armorType === 1
        ? { food: 120, wood: 120, stone: 100, iron: 180 } // Base costs for offensive armor
        : { food: 150, wood: 150, stone: 100, iron: 400 }; // Base costs for defensive armor

    // Adjust the cost if armories exist
     const armoryCount = buildingCounts[1] || 1; // You may want to dynamically calculate this based on your interior map data
    const multiplier = quantity / armoryCount;

    return {
        food: Math.ceil(baseCost.food * multiplier),
        wood: Math.ceil(baseCost.wood * multiplier),
        stone: Math.ceil(baseCost.stone * multiplier),
        iron: Math.ceil(baseCost.iron * multiplier),
    };
}, [tileData, buildingCounts]);




const calculateWeaponCost = useCallback((weaponType, quantity) => {
    if (!tileData) return;

    const baseCost = weaponType === 1
        ? { food: 120, wood: 180, stone: 100, iron: 300 } // Base costs for offensive armor
        : { food: 150, wood: 200, stone: 100, iron: 250 }; // Base costs for defensive armor

    // Adjust the cost if armories exist
    const blacksmithCount = buildingCounts[2] || 1;
    const multiplier = quantity / blacksmithCount;

    return {
        food: Math.ceil(baseCost.food * multiplier),
        wood: Math.ceil(baseCost.wood * multiplier),
        stone: Math.ceil(baseCost.stone * multiplier),
        iron: Math.ceil(baseCost.iron * multiplier),
    };
}, [tileData, buildingCounts]);


const calculateSoldierCost = useCallback((soldierType, quantity) => {
    if (!tileData) return;

    const baseCost = soldierType === 1
        ? { food: 400, wood: 200, stone: 150, iron: 100 } // Base costs for offensive soldier
        : { food: 400, wood: 200, stone: 150, iron: 100 }; // Base costs for defensive soldier

    // Adjust cost if a Fighting Pit exists
    const fightingPitCount = buildingCounts[4] || 1;
    const multiplier = quantity / fightingPitCount;

    return {
        food: Math.ceil(baseCost.food * multiplier),
        wood: Math.ceil(baseCost.wood * multiplier),
        stone: Math.ceil(baseCost.stone * multiplier),
        iron: Math.ceil(baseCost.iron * multiplier),
    };
}, [tileData, buildingCounts]);



const handleArmorInputChange = (armorType, value) => {
    const quantity = parseInt(value || "0", 10);

    const offensiveCost = calculateArmorCost(1, armorType === 1 ? quantity : armorQuantities.offensive);
    const defensiveCost = calculateArmorCost(2, armorType === 2 ? quantity : armorQuantities.defensive);

    setArmorCosts({
        food: offensiveCost.food + defensiveCost.food,
        wood: offensiveCost.wood + defensiveCost.wood,
        stone: offensiveCost.stone + defensiveCost.stone,
        iron: offensiveCost.iron + defensiveCost.iron,
    });

    setArmorQuantities((prev) => ({
        ...prev,
        [armorType === 1 ? 'offensive' : 'defensive']: value,
    }));

    // Show or hide the cost line based on input values
    setShowArmorCosts(quantity > 0 || (armorType === 1 ? armorQuantities.defensive : armorQuantities.offensive) > 0);
};




const handleWeaponInputChange = (weaponType, value) => {
    const quantity = parseInt(value || "0", 10);

    const offensiveCost = calculateWeaponCost(1, weaponType === 1 ? quantity : weaponQuantities.offensive);
    const defensiveCost = calculateWeaponCost(2, weaponType === 2 ? quantity : weaponQuantities.defensive);

    setWeaponCosts({
        food: offensiveCost.food + defensiveCost.food,
        wood: offensiveCost.wood + defensiveCost.wood,
        stone: offensiveCost.stone + defensiveCost.stone,
        iron: offensiveCost.iron + defensiveCost.iron,
    });

    setWeaponQuantities((prev) => ({
        ...prev,
        [weaponType === 1 ? 'offensive' : 'defensive']: value,
    }));

    // Show or hide the cost line based on input values
    setShowWeaponCosts(quantity > 0 || (weaponType === 1 ? weaponQuantities.defensive : weaponQuantities.offensive) > 0);
};


const handleSoldierInputChange = (soldierType, value) => {
    const quantity = parseInt(value || "0", 10);

    const offensiveCost = calculateSoldierCost(1, soldierType === 1 ? quantity : soldierQuantities.offensive);
    const defensiveCost = calculateSoldierCost(2, soldierType === 2 ? quantity : soldierQuantities.defensive);

    setSoldierCosts({
        food: offensiveCost.food + defensiveCost.food,
        wood: offensiveCost.wood + defensiveCost.wood,
        stone: offensiveCost.stone + defensiveCost.stone,
        iron: offensiveCost.iron + defensiveCost.iron,
    });

    setSoldierQuantities((prev) => ({
        ...prev,
        [soldierType === 1 ? 'offensive' : 'defensive']: value,
    }));

    setShowSoldierCosts(quantity > 0 || (soldierType === 1 ? soldierQuantities.defensive : soldierQuantities.offensive) > 0);
};





const calculateResources = useCallback((turns) => {
    if (!tileData || !tileCoords.bonusType || !buildingCounts) return;

    const houseCount = (buildingCounts[5] || 0) + 1; // Ensure at least a multiplier of 1

    let food = turns * houseCount;
    let wood = turns * houseCount;
    let stone = turns * houseCount;
    let iron = turns * houseCount;

    // Apply bonus based on the bonus type
    switch (tileCoords.bonusType) {
        case "Food":
            food += turns * houseCount;
            break;
        case "Wood":
            wood += turns * houseCount;
            break;
        case "Stone":
            stone += turns * houseCount;
            break;
        case "Iron":
            iron += turns * houseCount;
            break;
        default:
            break;
    }


    setCalculatedResources({ food, wood, stone, iron });
}, [tileData, tileCoords.bonusType, buildingCounts]);



useEffect(() => {
    if (tileData && tileData.inputTurns) {
        calculateResources(parseInt(tileData.inputTurns));
    }
}, [tileData?.inputTurns, calculateResources, tileData]);


const getMaxAllowedTurns = () => {
    if (!tileData) return 0;
    const maxTurns = turnsPerLevel - parseInt(tileData.accumulatedTurns);
    return Math.min(maxTurns, parseInt(tileData.turns)); // Limit by available turns
};



const fetchTileData = useCallback(async (x, y) => {
    try {
        const contract = await getTheLandSignerContract();
        const tileDataResponse = await contract.getTileData(x - 1, y - 1);
        const currentTurns = await contract.getTurn(x - 1, y - 1); // Fetch real-time turns

        // Convert BigNumber to string or number
        setTileData({
            food: tileDataResponse.food.toString(),
            wood: tileDataResponse.wood.toString(),
            stone: tileDataResponse.stone.toString(),
            iron: tileDataResponse.iron.toString(),
            level: tileDataResponse.level.toString(),
            accumulatedTurns: tileDataResponse.accumulatedTurns.toString(),
            turns: currentTurns.toString(), // Add turns
            inputTurns: "", // Initialize inputTurns
            offensiveArmor: tileDataResponse.offensiveArmor.toString(),
            defensiveArmor: tileDataResponse.defensiveArmor.toString(),
            offensiveWeapon: tileDataResponse.offensiveWeapon.toString(),
            defensiveWeapon: tileDataResponse.defensiveWeapon.toString(),
            offensiveSoldier: tileDataResponse.offensiveSoldier.toString(),
            defensiveSoldier: tileDataResponse.defensiveSoldier.toString(),
            techLevels: {
                offensiveTech: tileDataResponse.offensiveTech.toString(),
                defensiveTech: tileDataResponse.defensiveTech.toString()
            },
            points: tileDataResponse.points.toString()
        });
    } catch (error) {
        console.error("Error fetching tile data:", error);
        toast.error("Failed to fetch tile data.");
    }
}, []); // Add dependencies if required (e.g., external variables used inside the function)

const fetchTileTurns = async (x, y) => {
    try {
        const contract = await getTheLandSignerContract();
        const updatedTurnsX = await contract.getTurn(x - 1, y - 1); // Fetch real-time turns
        const updatedTurns = updatedTurnsX.toString();



        setTileData((prev) => ({
            ...prev,
            turns: updatedTurns, // Update turns in the state
        }));

        toast.success("Turns updated!");
    } catch (error) {
        console.error("Error fetching turns:", error);
        toast.error("Failed to fetch turns.");
    }
};



const fetchMarketplaceItemsByType = async () => {

  // label map (keys as numbers)
  const RESOURCE_LABELS = {
    1: "Food",
    2: "Wood",
    3: "Stone",
    4: "Iron",
    5: "Offensive Armor",
    6: "Defensive Armor",
    7: "Offensive Weapon",
    8: "Defensive Weapon",
  };

  try {
    setLoading(true);

    const market = await getMarketplaceSignerContract();

    // Ensure numeric type for the solidity fn param
    const rtNum = parseInt(selectedResourceType);
    if (!rtNum || isNaN(rtNum)) {
      toast.error("Select a valid resource type.");
      setMarketplaceItems([]);
      return;
    }

    // Fetch only this category
    const items = await market.getListingsByResourceType(tileCoords.x - 1, tileCoords.y -1, rtNum);

    const restype = RESOURCE_LABELS[rtNum] || "";

    // Map results (works for ethers v5/v6 named + indexed structs)
    const formattedItems = (items || []).map((item, index) => {
      const sellerX = item.sellerX ?? item[0];
      const sellerY = item.sellerY ?? item[1];
      const resourceType = item.resourceType ?? item[2];
      const amount = item.amount ?? item[3];
      const price = item.price ?? item[4];

       const isOwnListing =
   parseInt(sellerX) === tileCoords.x - 1 && parseInt(sellerY) === tileCoords.y - 1;

      return {
        id: index, // fallback index as id
        sellerX: parseInt(sellerX) + 1,
        sellerY: parseInt(sellerY) + 1,
        resourceTypeX: restype,
        resourceType: parseInt(resourceType),
        amount: parseInt(amount),
        price: parseInt(price),
        isOwnListing: isOwnListing
      };
    });

    setMarketplaceItems(formattedItems);
  } catch (error) {
    console.error("Error fetching marketplace items:", error);
    toast.error("Failed to load marketplace items.");
    setMarketplaceItems([]);
  } finally {
    setLoading(false);
  }
};





const listItemForSale = async () => {
    try {
        setLoading(true);
        

        const resourceType = parseInt(selectedResource);
        const amount = parseInt(sellAmount);
        const price = parseInt(sellPrice) * 10 ** 6;


        if (resourceType === 1 && tileData.food < amount ) {
            toast.error("Not Enough Food");
            setLoading(false);
            return;
        } else if (resourceType === 2 && tileData.wood < amount ) {
            toast.error("Not Enough Wood");
            setLoading(false);
            return;
        } else if (resourceType === 3 && tileData.stone < amount ) {
            toast.error("Not Enough Stone");
            setLoading(false);
            return;
        } else if (resourceType === 4 && tileData.iron < amount ) {
            toast.error("Not Enough Iron");
            setLoading(false);
            return;
        } else if (resourceType === 5 && tileData.offensiveArmor < amount ) {
            toast.error("Not Enough Offensive Armor");
            setLoading(false);
            return;
        } else if (resourceType === 6 && tileData.defensiveArmor < amount ) {
            toast.error("Not Enough Defensive Armor");
            setLoading(false);
            return;
        } else if (resourceType === 7 && tileData.offensiveWeapon < amount ) {
            toast.error("Not Enough Offensive Weapon");
            setLoading(false);
            return;
        } else if (resourceType === 8 && tileData.defensiveWeapon < amount ) {
            toast.error("Not Enough Defensive Weapon");
            setLoading(false);
            return;
        }




        if (resourceType <= 4) {

        if (amount < 10000) {
            toast.error("Amount must be greater than 10000");
            setLoading(false);
            return;
        } 

        } else {

            if (amount < 100) {
            toast.error("Amount must be greater than 100");
            setLoading(false);
            return;
        } 
        }

        if (price < 10000000) {
            toast.error("Price must be greater than 10");
            setLoading(false);
            return;
        }

const contract = await getMarketplaceSignerContract();
        const x = tileCoords.x - 1;
        const y = tileCoords.y - 1;


        // compute the same key the contract uses: (x << 8) | y
    const tileKey = x * 256 + y;

    // 1) hard cap: max 5 active listings per tile
    const active = await contract.activeListingsByTile(tileKey); // public mapping getter
    if (parseInt(active) >= 5) {
      toast.info("You already have 5 active listings for this realm. Remove one first.");
      return; // stop before any tx
    }


        const tx = await contract.listItemForSale(x, y, resourceType, amount, price);
        await tx.wait();

        toast.success("Item listed successfully!");
        await fetchTileData(tileCoords.x, tileCoords.y); // Refresh tile data

        // Reset the input fields after successful listing
        setSellAmount("");
        setSellPrice("");
    } catch (error) {
        console.error("Error listing item:", error);
        toast.error("Failed to list item.");
    } finally {
        setLoading(false);
    }
};





const buyItem = async (item, index) => {
    try {
        setLoading(true);




        const TokencontractSigner = await getTokenSignerContract();

        const value = parseInt(item.price);

        
                const Allowancetx = await TokencontractSigner.increaseAllowance(
                  MarketplacecontractAddress,
                  value
                );
                await Allowancetx.wait();



        const contract = await getMarketplaceSignerContract();

        const tx = await contract.buyItem(
            tileCoords.x - 1,
            tileCoords.y - 1,
            item.resourceType,
            index
        );
        await tx.wait();

        toast.success("Item purchased successfully!");
        await fetchTileData(tileCoords.x, tileCoords.y); // Refresh tile data
        await fetchMarketplaceItemsByType(); // Refresh marketplace items
    } catch (error) {
        console.error("Error buying item:", error);
        toast.error("Failed to buy item.");
    } finally {
        setLoading(false);
    }
};





useEffect(() => {
    if (tileCoords && tileCoords.x !== null && tileCoords.y !== null) {
        fetchTileData(tileCoords.x, tileCoords.y);
    }
}, [tileCoords, fetchTileData]); // Include fetchTileData as a dependency



const placeBuildingOnTile = useCallback(
    async (mainX, mainY, interiorX, interiorY, buildingType, onTransactionStart, onTransactionEnd) => {
        setLoading(true);
        gameRef.current.sounds.construction.play();
        try {
            onTransactionStart(); // Temporarily place the transparent image
            const contract = await getTheLandSignerContract();

            
            const tx = await contract.placeBuilding(mainX, mainY, interiorX, interiorY, buildingType);
            await tx.wait();

            onTransactionEnd(true); // Confirm the image placement
            toast.success('Building placed successfully!');

            // Fetch updated tile data after the building is placed
            await fetchTileData(tileCoords.x, tileCoords.y);
            setArmorQuantities({ offensive: 0, defensive: 0 });
setWeaponQuantities({ offensive: 0, defensive: 0 });
setSoldierQuantities({ offensive: 0, defensive: 0 });
setArmorCosts({ food: 0, wood: 0, stone: 0, iron: 0 });
setWeaponCosts({ food: 0, wood: 0, stone: 0, iron: 0 });
setSoldierCosts({ food: 0, wood: 0, stone: 0, iron: 0 });
setShowArmorCosts(false);
setWeaponCosts(false);
setSoldierCosts(false);

            const updatedBuildings = await fetchAllBuildings(tileCoords.x - 1, tileCoords.y - 1);

const updatedCounts = {};
updatedBuildings.forEach((row) => {
    row.forEach((type) => {
        if (type > 0) {
            updatedCounts[type] = (updatedCounts[type] || 0) + 1;
        }
    });
});
setBuildingCounts(updatedCounts);


            return true; // Indicate success
        } catch (error) {
            console.error('Error placing building:', error);
            onTransactionEnd(false); // Remove the transparent image
            toast.error('Wrong Location or Not Enough Resources !!!');
            return false; // Indicate failure
        } finally {
            setLoading(false);
        }
    },
    [tileCoords, fetchTileData] // Include necessary dependencies
);









const fetchAllBuildings = async (mainX, mainY) => {
    try {
        const contract = await getTheLandSignerContract();
        const buildings = await contract.getAllBuildings(mainX, mainY);
        return buildings; // Returns a 9x9 array of building types
    } catch (error) {
        console.error('Error fetching all buildings:', error);
        return Array(9).fill(Array(9).fill(0)); // Return an empty grid on error
    } finally {
        setLoading(false);
      }
};


 const toggleMusic = () => {
    if (musicRef2.current) {
      if (isMusicPlaying) {
        musicRef2.current.pause();
      } else {
        musicRef2.current.play();
      }
      setIsMusicPlaying(!isMusicPlaying);
    }
  };


    const loginMetaMask = async () => {
        if (window.ethereum) {
            try {
                const accounts = await window.ethereum.request({ method: 'eth_requestAccounts' });
                if (accounts.length > 0) {
                    setIsMetaMaskConnected(true);
                    setMetaMaskAccount(accounts[0]);
                }
            } catch (error) {
                console.error('MetaMask login failed', error);
            }
        } else {
            alert('MetaMask not detected');
        }
    };

    useEffect(() => {
        // Initialize the MetaMask connection state
        if (!isMetaMaskConnected) {
            loginMetaMask();
        }
    }, [isMetaMaskConnected]);

    useEffect(() => {
        if (gameRef.current) {
            return;
        }

        document.body.style.overflow = 'hidden';
        document.documentElement.style.overflow = 'hidden';

        const disableContextMenu = (e) => {
            if (e.target.tagName === 'INPUT' && e.target.type === 'text') {
                return;
            }
            e.preventDefault();
        };
        window.addEventListener('contextmenu', disableContextMenu);

        const config = {
            type: Phaser.AUTO,
            width: window.innerWidth,
            height: window.innerHeight,
            parent: 'phaser-container',
            scene: {
                preload: preload,
                create: create,
                update: update,
            },
            scale: {
                mode: Phaser.Scale.RESIZE,
                autoCenter: Phaser.Scale.CENTER_BOTH,
            },
            audio: {
                disableWebAudio: true,
            },
            transparent: true,
            banner: false,
            dom: {
    createContainer: true,
  },
        };

        gameRef.current = new Phaser.Game(config);

        let zoomLevel = 0.4;

        function preload() {
            this.load.audio('backgroundMusic2', backgroundMusicFile);

            this.load.audio('armorySound', armorySound);
            this.load.audio('turnSound', turnSound);
            this.load.audio('constructionSound', constructionSound);
            this.load.audio('clancreateSound', clancreateSound);
            this.load.audio('trainingSound', trainingSound);
            this.load.audio('upgradeSound', upgradeSound);

            this.load.image('grassX', grassXImage);
            this.load.image('foodX', foodXImage);
            this.load.image('woodX', woodXImage);
            this.load.image('stoneX', stoneXImage);
            this.load.image('ironX', ironXImage);
            this.load.image('elders', eldersImage);
            this.load.image('armory', armoryImage);
            this.load.image('blacksmith', blacksmithImage);
            this.load.image('clanhall', clanhallImage);
            this.load.image('fightingpit', fightingpitImage);
            this.load.image('house', houseImage);
            this.load.image('market', marketImage);
            this.load.image('tower', towerImage);
            this.load.image('workshop', workshopImage);

            this.load.image('food', foodImage);
            this.load.image('wood', woodImage);
            this.load.image('stone', stoneImage);
            this.load.image('iron', ironImage);
            this.load.image('turns', turnsImage);

            this.load.image('defensivearmor', defensiveArmorImage);
            this.load.image('offensivearmor', offensiveArmorImage);

            this.load.image('defensiveweapon', defensiveWeaponImage);
            this.load.image('offensiveweapon', offensiveWeaponImage);

            this.load.image('defensivesoldier', defensiveSoldierImage);
            this.load.image('offensivesoldier', offensiveSoldierImage);

            this.load.image('clockLoading', clockLoadingImage);
            this.load.image('forgekLoading', forgekLoadingImage);
            this.load.image('offensiveLoading', offensiveLoadingImage);
            this.load.image('defensiveLoading', defensiveLoadingImage);
            this.load.image('clancreateLoading', clancreateLoadingImage);

            this.load.image('offensiveTechLoading', offensiveTechLoadingImage);
            this.load.image('defensiveTechLoading', defensiveTechLoadingImage);
            

        }

        async function create() {

            gameRef.current.sounds = {
  armory: this.sound.add('armorySound', { volume: 0.6 }),
  turn: this.sound.add('turnSound', { volume: 0.6 }),
   construction: this.sound.add('constructionSound', { volume: 0.6 }),
   clancreate: this.sound.add('clancreateSound', { volume: 0.6 }),
   training: this.sound.add('trainingSound', { volume: 0.3 }),
   upgrade: this.sound.add('upgradeSound', { volume: 0.6 }),

};



            this.buildingSprites = Array(mapSize).fill(null).map(() => Array(mapSize).fill(null));

            const tileWidth = 386;
            const visibleTileHeight = 193;
            const overlap = visibleTileHeight / 2;
            const halfTileWidth = tileWidth / 2;

            const totalMapHeight = ((mapSize - 1) * overlap + visibleTileHeight / 2) * 2;
            const offsetX = window.innerWidth / 2;

            const { x: mainX, y: mainY } = tileCoords;
            const buildings = await fetchAllBuildings(mainX - 1, mainY - 1);

                  const counts = {};
              
                  buildings.forEach((row) => {
                    row.forEach((buildingType) => {
                      if (buildingType > 0) {
                        counts[buildingType] = (counts[buildingType] || 0) + 1;
                      }
                    });
                  });
              
                  setBuildingCounts(counts);
               
musicRef2.current = this.sound.add('backgroundMusic2', {
        loop: true,
        volume: 0.5,
      });






            this.lights.enable();
            this.lights.setAmbientColor(0x9999);
            this.lights.addLight(window.innerWidth * 2.5, -1500, 800).setColor(0xfff8e1).setIntensity(2.5);

            function tileToWorldPosition(x, y) {
                const worldX = (x - y) * halfTileWidth + offsetX;
                const worldY = (x + y) * overlap;
                return { worldX, worldY };
            }


            let landX = 'grassX';


            switch (tileCoords.bonusType) {
        case "Food":
            landX = 'foodX';
            break;
        case "Wood":
            landX = 'woodX';
            break;
        case "Stone":
            landX = 'stoneX';
            break;
        case "Iron":
            landX = 'ironX';
            break;
        default:
            break;
    }

 for (let y = -mapSize * 4; y < mapSize * 8; y++) {
                for (let x = -mapSize * 4; x < mapSize * 8; x++) {
                    const { worldX, worldY } = tileToWorldPosition(x, y);
            this.add.image(worldX, worldY, landX).setDepth(worldY - 1000);
                }}


            for (let y = 0; y < mapSize; y++) {
                for (let x = 0; x < mapSize; x++) {
                    const { worldX, worldY } = tileToWorldPosition(x, y);
                    this.add.image(worldX, worldY, 'grassX').setDepth(worldY);
                    

                    const buildingType = buildings[x][y]; // Get building type from the fetched data
                    if (buildingType > 0 && buildingImageMap[buildingType]) {
                        const buildingImage = buildingImageMap[buildingType];
                        const building = this.add.image(worldX, worldY, buildingImage).setDepth(worldY + 1);
                        this.buildingSprites[x][y] = building;
            
                        // Add interactivity specifically for the armory
                        if (buildingImage === 'armory') {
                            building.setInteractive({ pixelPerfect: true });
                            makeContextOpener(building, () => {
  setSelectedInteriorCoords({ x, y });
  setinteractionMenuType('armory');
});


                            const forgeOverlay = this.add.dom(worldX, worldY).createFromHTML(`
    <img 
      src="${forgekLoadingImage}" 
      style="width: 150px; height: 150px; display: none; filter: brightness(1.9); transform: translate(-120px, -80px);" 
    />
  `);
  forgeOverlay.setDepth(worldY + 2);

  // Save references so you can toggle them later
  if (!gameRef.current.armoryForgeOverlays) {
    gameRef.current.armoryForgeOverlays = [];
  }

gameRef.current.armoryForgeOverlays.push({ 
  x, 
  y, 
  overlay: forgeOverlay 
});


                        } else if (buildingImage === 'blacksmith') {
                            building.setInteractive({ pixelPerfect: true });
                            makeContextOpener(building, () => {
  setSelectedInteriorCoords({ x, y });
  setinteractionMenuType('blacksmith');
});



                            const forgeOverlay = this.add.dom(worldX, worldY).createFromHTML(`
    <img 
      src="${forgekLoadingImage}" 
      style="width: 150px; height: 150px; display: none; filter: brightness(1.9); transform: translate(-120px, -80px);" 
    />
  `);
  forgeOverlay.setDepth(worldY + 2);

  // Save references so you can toggle them later
  if (!gameRef.current.blacksmithForgeOverlays) {
    gameRef.current.blacksmithForgeOverlays = [];
  }

gameRef.current.blacksmithForgeOverlays.push({ 
  x, 
  y, 
  overlay: forgeOverlay 
});


                        } else if (buildingImage === 'fightingpit') {
                            building.setInteractive({ pixelPerfect: true });
                            makeContextOpener(building, () => {
  setSelectedInteriorCoords({ x, y });
  setinteractionMenuType('train-soldier');
});



                            const trainingOffensiveOverlay = this.add.dom(worldX, worldY).createFromHTML(`
    <img 
      src="${offensiveLoadingImage}" 
      style="width: 120px; height: 120px; display: none; filter: brightness(1.9); transform: translate(-60px, -40px);" 
    />
  `);
  trainingOffensiveOverlay.setDepth(worldY + 2);

  // Save references so you can toggle them later
  if (!gameRef.current.trainingOffensiveOverlays) {
    gameRef.current.trainingOffensiveOverlays = [];
  }
  

gameRef.current.trainingOffensiveOverlays.push({ 
  x, 
  y, 
  overlay: trainingOffensiveOverlay
});




   const trainingDefensiveOverlay = this.add.dom(worldX, worldY).createFromHTML(`
    <img 
      src="${defensiveLoadingImage}" 
      style="width: 120px; height: 120px; display: none; filter: brightness(1.9); transform: translate(-60px, -40px);" 
    />
  `);
  trainingDefensiveOverlay.setDepth(worldY + 2);

  // Save references so you can toggle them later
  if (!gameRef.current.trainingDefensiveOverlays) {
    gameRef.current.trainingDefensiveOverlays = [];
  }
 
gameRef.current.trainingDefensiveOverlays.push({ 
  x, 
  y, 
  overlay: trainingDefensiveOverlay 
});



                        } else if (buildingImage === 'house') {
                            building.setInteractive({ pixelPerfect: true });
                            makeContextOpener(building, () => {
  setSelectedInteriorCoords({ x, y });
  setinteractionMenuType('house-info');
});


                            const houseClockOverlay = this.add.dom(worldX, worldY).createFromHTML(`
    <img 
      src="${clockLoadingImage}" 
      style="width: 96px; height: 96px; display: none; filter: brightness(2.1); transform: translate(-40px, -10px);" 
    />
  `);
  houseClockOverlay.setDepth(worldY + 2);

  // Save references so you can toggle them later
  if (!gameRef.current.houseClockOverlays) {
    gameRef.current.houseClockOverlays = [];
  }
 gameRef.current.houseClockOverlays.push({ 
  x, 
  y, 
  overlay: houseClockOverlay
});



                        } else if (buildingImage === 'tower') {
                            building.setInteractive({ pixelPerfect: true });
                            makeContextOpener(building, () => {
  setSelectedInteriorCoords({ x, y });
  setinteractionMenuType('tower-info');
});
                        } else if (buildingImage === 'workshop') {
                            building.setInteractive({ pixelPerfect: true });
                            makeContextOpener(building, () => {
  setSelectedInteriorCoords({ x, y });
  setinteractionMenuType('workshop');
});



                            const offensiveTechOverlay = this.add.dom(worldX, worldY).createFromHTML(`
    <img 
      src="${offensiveTechLoadingImage}" 
      style="width: 96px; height: 96px; display: none; filter: brightness(1.3); transform: translate(-60px, -20px);" 
    />
  `);
  offensiveTechOverlay.setDepth(worldY + 2);

  // Save references so you can toggle them later
  if (!gameRef.current.offensiveTechOverlays) {
    gameRef.current.offensiveTechOverlays = [];
  }


gameRef.current.offensiveTechOverlays.push({ 
  x, 
  y, 
  overlay: offensiveTechOverlay 
});





  const defensiveTechOverlay = this.add.dom(worldX, worldY).createFromHTML(`
    <img 
      src="${defensiveTechLoadingImage}" 
      style="width: 96px; height: 96px; display: none; filter: brightness(1.3); transform: translate(-60px, -20px);" 
    />
  `);
  defensiveTechOverlay.setDepth(worldY + 2);

  // Save references so you can toggle them later
  if (!gameRef.current.defensiveTechOverlays) {
    gameRef.current.defensiveTechOverlays = [];
  }
  gameRef.current.defensiveTechOverlays.push({ 
  x, 
  y, 
  overlay: defensiveTechOverlay 
});




                        } else if (buildingImage === 'market') {
                            building.setInteractive({ pixelPerfect: true });
                            makeContextOpener(building, () => {
  setSelectedInteriorCoords({ x, y });
  setinteractionMenuType('marketplace');
});
                        } else if (buildingImage === 'clanhall') {
                            building.setInteractive({ pixelPerfect: true });
                            makeContextOpener(building, () => {
  setSelectedInteriorCoords({ x, y });
  setinteractionMenuType('clanhall');
});



                            const flagOverlay = this.add.dom(worldX, worldY).createFromHTML(`
    <img 
      src="${clancreateLoadingImage}" 
      style="width: 150px; height: 150px; display: none; filter: brightness(2.1); transform: translate(-120px, -90px);" 
    />
  `);
  flagOverlay.setDepth(worldY + 2);

  // Save references so you can toggle them later
  if (!gameRef.current.flagOverlays) {
    gameRef.current.flagOverlays = [];
  }
gameRef.current.flagOverlays.push({ 
  x, 
  y, 
  overlay: flagOverlay 
});



                        }
                        
                    }
                    

                    if (x === 4 && y === 4) {
                      const elders = this.add.image(worldX, worldY, 'elders').setDepth(worldY + 1);
      
                      // Add right-click listener to the elders image
                      elders.setInteractive({
                        pixelPerfect: true
                      });
                      makeContextOpener(elders, () => {
  setinteractionMenuType("buildings");
});

                      // Add the DOM element for loading spinner
  const clockOverlay = this.add.dom(worldX, worldY).createFromHTML(`
    <img 
    src="${clockLoadingImage}" 
    style="width:96px; height:96px; display:none; filter: brightness(2.1); transform: translate(-40px, -10px);" 
  />
  `);
  clockOverlay.setDepth(worldY + 2); // Make sure it's above the elders

  // Save to a ref so we can toggle visibility later
  gameRef.current.clockOverlay = clockOverlay;


                  }
                }
            }

            this.cameras.main.setZoom(zoomLevel);
            const mapCenterY = totalMapHeight / 2;
            this.cameras.main.scrollY = mapCenterY - window.innerHeight / 2;
            

            let isDragging = false;
            let dragStartX = 0;
            let dragStartY = 0;
            let cameraStartX = 0;
            let cameraStartY = 0;


            let lastEmptyTap = 0, lastEmptyX = 0, lastEmptyY = 0;

this.input.on('pointerdown', (pointer, gameObjects) => {
  // Right-click still works
  if (pointer.button === 2 && !gameObjects.length) {
    setinteractionMenuType("home");
    return;
  }

  // Double-tap empty area -> home
  if (!gameObjects.length) {
    const now = performance.now();
    const dx = pointer.x - lastEmptyX;
    const dy = pointer.y - lastEmptyY;
    const dist2 = dx*dx + dy*dy;

    if (now - lastEmptyTap <= DOUBLE_TAP_MS && dist2 <= DOUBLE_TAP_MOVE_PX * DOUBLE_TAP_MOVE_PX) {
      setinteractionMenuType("home");
      lastEmptyTap = 0; // reset
    } else {
      lastEmptyTap = now;
      lastEmptyX = pointer.x;
      lastEmptyY = pointer.y;
    }
  }
});



            const previewImage = this.add
                .image(0, 0, '')
                .setAlpha(0.5)
                .setVisible(false)
                .setDepth(10000); // Make sure it's above everything else
            buildingPreviewRef.current = previewImage;


            this.input.on('pointerdown', (pointer) => {
                if (pointer.button === 2) {
                    // Deselect building
                    setSelectedBuilding(null);
                    selectedBuildingRef.current = null;
        
                    // Hide the preview image
                    if (buildingPreviewRef.current) {
                        buildingPreviewRef.current.setVisible(false);
                    }
                }
            });

            this.input.on('pointermove', (pointer) => {
                if (selectedBuildingRef.current) {
                    const worldX = pointer.worldX;
                    const worldY = pointer.worldY;

                    const x = Math.floor((worldY / overlap + (worldX - offsetX) / halfTileWidth) / 2);
                    const y = Math.floor((worldY / overlap - (worldX - offsetX) / halfTileWidth) / 2);

                    if (x >= 0 && x < mapSize && y >= 0 && y < mapSize) {
                        const { worldX, worldY } = tileToWorldPosition(x, y);
                        previewImage.setPosition(worldX, worldY);
                        previewImage.setTexture(selectedBuildingRef.current);
                        previewImage.setVisible(true);
                    } else {
                        previewImage.setVisible(false);
                    }
                } else {
                    previewImage.setVisible(false);
                }
            });



            this.input.on('pointerdown', async function (pointer) {
                if (pointer.button === 0 && selectedBuildingRef.current) {

                    const worldX = pointer.worldX;
                    const worldY = pointer.worldY;
            
                    const x = Math.floor((worldY / overlap + (worldX - offsetX) / halfTileWidth) / 2);
                    const y = Math.floor((worldY / overlap - (worldX - offsetX) / halfTileWidth) / 2);
            
                    if (x >= 0 && x < mapSize && y >= 0 && y < mapSize) {
                        const { worldX, worldY } = tileToWorldPosition(x, y);
                        const buildingType = Object.keys(buildingImageMap).find(
                            (key) => buildingImageMap[key] === selectedBuildingRef.current
                        );
            
                        if (buildingType) {
                            // Add a temporary transparent image
                            const tempImage = this.add.image(worldX, worldY, selectedBuildingRef.current)
                                .setAlpha(0.5)
                                .setDepth(worldY + 1);

                                this.buildingSprites[x][y] = tempImage;
            
                            const onTransactionStart = () => {
                                tempImage.setVisible(true);
                            };
            
                            const onTransactionEnd = (success) => {
  if (!success) {
    tempImage.destroy(); // remove if placement fails
    return;
  }

  tempImage.setAlpha(1);            // make the image permanent
  tempImage.setInteractive({ pixelPerfect: true });

  const imageKey = selectedBuildingRef.current;
  const openMenu = (menu) => {
    setSelectedInteriorCoords({ x, y });
    setinteractionMenuType(menu);
  };

  // use our helper so right-click *and* double-tap open the menu
  // NOTE: makeContextOpener(...) must be defined earlier in create()
  switch (imageKey) {
    case 'armory': {
      makeContextOpener(tempImage, () => openMenu('armory'));

      // ---- overlay (unchanged) ----
      const forgeOverlay = this.add.dom(worldX, worldY).createFromHTML(`
        <img 
          src="${forgekLoadingImage}" 
          style="width: 150px; height: 150px; display: none; filter: brightness(1.9); transform: translate(-120px, -80px);" 
        />
      `);
      forgeOverlay.setDepth(worldY + 2);
      if (!gameRef.current.armoryForgeOverlays) gameRef.current.armoryForgeOverlays = [];
      gameRef.current.armoryForgeOverlays.push({ x, y, overlay: forgeOverlay });
      break;
    }

    case 'blacksmith': {
      makeContextOpener(tempImage, () => openMenu('blacksmith'));

      const forgeOverlay = this.add.dom(worldX, worldY).createFromHTML(`
        <img 
          src="${forgekLoadingImage}" 
          style="width: 150px; height: 150px; display: none; filter: brightness(1.9); transform: translate(-120px, -80px);" 
        />
      `);
      forgeOverlay.setDepth(worldY + 2);
      if (!gameRef.current.blacksmithForgeOverlays) gameRef.current.blacksmithForgeOverlays = [];
      gameRef.current.blacksmithForgeOverlays.push({ x, y, overlay: forgeOverlay });
      break;
    }

    case 'fightingpit': {
      makeContextOpener(tempImage, () => openMenu('train-soldier'));

      const trainingOffensiveOverlay = this.add.dom(worldX, worldY).createFromHTML(`
        <img 
          src="${offensiveLoadingImage}" 
          style="width: 120px; height: 120px; display: none; filter: brightness(1.9); transform: translate(-60px, -40px);" 
        />
      `);
      trainingOffensiveOverlay.setDepth(worldY + 2);
      if (!gameRef.current.trainingOffensiveOverlays) gameRef.current.trainingOffensiveOverlays = [];
      gameRef.current.trainingOffensiveOverlays.push({ x, y, overlay: trainingOffensiveOverlay });

      const trainingDefensiveOverlay = this.add.dom(worldX, worldY).createFromHTML(`
        <img 
          src="${defensiveLoadingImage}" 
          style="width: 120px; height: 120px; display: none; filter: brightness(1.9); transform: translate(-60px, -40px);" 
        />
      `);
      trainingDefensiveOverlay.setDepth(worldY + 2);
      if (!gameRef.current.trainingDefensiveOverlays) gameRef.current.trainingDefensiveOverlays = [];
      gameRef.current.trainingDefensiveOverlays.push({ x, y, overlay: trainingDefensiveOverlay });
      break;
    }

    case 'house': {
      makeContextOpener(tempImage, () => openMenu('house-info'));

      const houseClockOverlay = this.add.dom(worldX, worldY).createFromHTML(`
        <img 
          src="${clockLoadingImage}" 
          style="width: 96px; height: 96px; display: none; filter: brightness(2.1); transform: translate(-40px, -10px);" 
        />
      `);
      houseClockOverlay.setDepth(worldY + 2);
      if (!gameRef.current.houseClockOverlays) gameRef.current.houseClockOverlays = [];
      gameRef.current.houseClockOverlays.push({ x, y, overlay: houseClockOverlay });
      break;
    }

    case 'tower': {
      makeContextOpener(tempImage, () => openMenu('tower-info'));
      break;
    }

    case 'workshop': {
      makeContextOpener(tempImage, () => openMenu('workshop'));

      const offensiveTechOverlay = this.add.dom(worldX, worldY).createFromHTML(`
        <img 
          src="${offensiveTechLoadingImage}" 
          style="width: 96px; height: 96px; display: none; filter: brightness(1.3); transform: translate(-60px, -20px);" 
        />
      `);
      offensiveTechOverlay.setDepth(worldY + 2);
      if (!gameRef.current.offensiveTechOverlays) gameRef.current.offensiveTechOverlays = [];
      gameRef.current.offensiveTechOverlays.push({ x, y, overlay: offensiveTechOverlay });

      const defensiveTechOverlay = this.add.dom(worldX, worldY).createFromHTML(`
        <img 
          src="${defensiveTechLoadingImage}" 
          style="width: 96px; height: 96px; display: none; filter: brightness(1.3); transform: translate(-60px, -20px);" 
        />
      `);
      defensiveTechOverlay.setDepth(worldY + 2);
      if (!gameRef.current.defensiveTechOverlays) gameRef.current.defensiveTechOverlays = [];
      gameRef.current.defensiveTechOverlays.push({ x, y, overlay: defensiveTechOverlay });
      break;
    }

    case 'market': {
      makeContextOpener(tempImage, () => openMenu('marketplace'));
      break;
    }

    case 'clanhall': {
      makeContextOpener(tempImage, () => openMenu('clanhall'));

      const flagOverlay = this.add.dom(worldX, worldY).createFromHTML(`
        <img 
          src="${clancreateLoadingImage}" 
          style="width: 150px; height: 150px; display: none; filter: brightness(2.1); transform: translate(-120px, -90px);" 
        />
      `);
      flagOverlay.setDepth(worldY + 2);
      if (!gameRef.current.flagOverlays) gameRef.current.flagOverlays = [];
      gameRef.current.flagOverlays.push({ x, y, overlay: flagOverlay });
      break;
    }

    default:
      // no-op
      break;
  }
};



                            
            
                            await placeBuildingOnTile(
                                tileCoords.x - 1, // Main X coordinate
                                tileCoords.y - 1, // Main Y coordinate
                                x,
                                y,
                                parseInt(buildingType),
                                onTransactionStart,
                                onTransactionEnd
                            );

                            

            
                            selectedBuildingRef.current = null; // Reset the selected building
                        }
                    }
                } else if (pointer.button === 0 && !selectedBuildingRef.current) {
                    isDragging = true;
                    dragStartX = pointer.x;
                    dragStartY = pointer.y;
                    cameraStartX = this.cameras.main.scrollX;
                    cameraStartY = this.cameras.main.scrollY;
                }
            }, this);
            
            



            this.input.on('pointermove', function (pointer) {

    

                 if (isDragging) {
                    const zoom = this.cameras.main.zoom;
                    const dragX = (dragStartX - pointer.x) / zoom;
                    const dragY = (dragStartY - pointer.y) / zoom;
                
                    let newScrollX = cameraStartX + dragX;
                    let newScrollY = cameraStartY + dragY;
                
                    // Get dimensions of the full map (after scaling)
                    const mapWidth = 8000; // your large map image width
                    const mapHeight = 4600; // your large map image height
                
                    const viewWidth = this.scale.width / zoom;
                    const viewHeight = this.scale.height / zoom;
                
                    // Calculate scroll limits
                    const minScrollX = (- mapWidth - viewWidth) / 3;
                    const maxScrollX = (mapWidth + viewWidth) / 3;
                
                    const minScrollY = (- mapHeight - viewHeight) / 4;
                    const maxScrollY = (mapHeight + viewHeight) / 2;
                
                    // Clamp camera position
                    this.cameras.main.scrollX = Phaser.Math.Clamp(newScrollX, minScrollX, maxScrollX);
                    this.cameras.main.scrollY = Phaser.Math.Clamp(newScrollY, minScrollY, maxScrollY);
                  }




            }, this);

            this.input.on('pointerup', function (pointer) {
                if (pointer.button === 0) {
                    isDragging = false;
                }
            }, this);

            this.input.on('wheel', (pointer, gameObjects, deltaX, deltaY, deltaZ) => {
                if (deltaY > 0) {
                    zoomLevel = Phaser.Math.Clamp(zoomLevel - 0.04, 0.4, 0.8);
                } else {
                    zoomLevel = Phaser.Math.Clamp(zoomLevel + 0.04, 0.4, 0.8);
                }
                this.cameras.main.setZoom(zoomLevel);
            });
        }

        function update() {}

        return () => {
          if (gameRef.current) {
            gameRef.current.destroy(true); // Destroy the Phaser game instance
            gameRef.current = null; // Reset the reference
          }
          
          document.body.style.overflow = '';
          document.documentElement.style.overflow = '';
        };
        
        
    }, [buildingImageMap, tileCoords, placeBuildingOnTile]);

    useEffect(() => {
  if (gameRef.current && gameRef.current.clockOverlay) {
    const imgEl = gameRef.current.clockOverlay.getChildByName('');
    if (imgEl) {
      imgEl.style.display = loadingTurns ? 'block' : 'none';
    }
  }
}, [loadingTurns]);


useEffect(() => {
  if (gameRef.current?.houseClockOverlays) {
    for (const entry of gameRef.current.houseClockOverlays) {
      const imgEl = entry.overlay.getChildByName(''); 
      if (imgEl) {
        imgEl.style.display = loadingTurns ? 'block' : 'none';
      }
    }
  }
}, [loadingTurns]);




useEffect(() => {
  if (gameRef.current?.offensiveTechOverlays) {
    for (const entry of gameRef.current.offensiveTechOverlays) {
      const imgEl = entry.overlay.getChildByName(''); 
      if (imgEl) {
        imgEl.style.display = laodingOffensiveTech ? 'block' : 'none';
      }
    }
  }
}, [laodingOffensiveTech]);


useEffect(() => {
  if (gameRef.current?.defensiveTechOverlays) {
    for (const entry of gameRef.current.defensiveTechOverlays) {
      const imgEl = entry.overlay.getChildByName(''); 
      if (imgEl) {
        imgEl.style.display = loadingDefensiveTech ? 'block' : 'none';
      }
    }
  }
}, [loadingDefensiveTech]);



useEffect(() => {
  if (gameRef.current?.flagOverlays) {
    for (const entry of gameRef.current.flagOverlays) {
      const imgEl = entry.overlay.getChildByName(''); 
      if (imgEl) {
        imgEl.style.display = loadingClanCreate ? 'block' : 'none';
      }
    }
  }
}, [loadingClanCreate]);



useEffect(() => {
  if (gameRef.current?.armoryForgeOverlays) {
    for (const entry of gameRef.current.armoryForgeOverlays) {
      const imgEl = entry.overlay.getChildByName(''); 
      if (imgEl) {
        imgEl.style.display = loadingArmoryForge ? 'block' : 'none';
      }
    }
  }
}, [loadingArmoryForge]);


useEffect(() => {
  if (gameRef.current?.blacksmithForgeOverlays) {
    for (const entry of gameRef.current.blacksmithForgeOverlays) {
      const imgEl = entry.overlay.getChildByName(''); 
      if (imgEl) {
        imgEl.style.display = loadingBlacksmithForge ? 'block' : 'none';
      }
    }
  }
}, [loadingBlacksmithForge]);




useEffect(() => {
  if (gameRef.current?.trainingOffensiveOverlays) {
    for (const entry of gameRef.current.trainingOffensiveOverlays) {
      const imgEl = entry.overlay.getChildByName(''); 
      if (imgEl) {
        imgEl.style.display = loadingOffensiveTraining ? 'block' : 'none';
      }
    }
  }
}, [loadingOffensiveTraining]);




useEffect(() => {
  if (gameRef.current?.trainingDefensiveOverlays) {
    for (const entry of gameRef.current.trainingDefensiveOverlays) {
      const imgEl = entry.overlay.getChildByName(''); 
      if (imgEl) {
        imgEl.style.display = loadingDefensiveTraining ? 'block' : 'none';
      }
    }
  }
}, [loadingDefensiveTraining]);



    useEffect(() => {
      // Update the ref whenever `selectedBuilding` changes
      selectedBuildingRef.current = selectedBuilding;
  }, [selectedBuilding]);


  const executeUseTurns = async (turns, tileCoords, toast) => {
    if (!tileCoords.x || !tileCoords.y) {
        toast.error("Please select a tile first");
        return;
    }

    setLoadingTurns(true);
    gameRef.current.sounds.turn.play();

    try {
        const contract = await getTheLandSignerContract(); // Replace with your function to get a signer instance
        const feeWei = await contract.turnFeeWei();
        const tx = await contract.useTurns(
      turns,
      tileCoords.x - 1,
      tileCoords.y - 1,
      { value: feeWei } // 👈 sends the native coin (e.g., 0.1 ETH) with the tx
    );
        await tx.wait();

        // Fetch updated tile data after the transaction
        await fetchTileData(tileCoords.x, tileCoords.y);
        await fetchDefenderCooldown(tileCoords.x, tileCoords.y);
        
        toast.success(`Successfully used ${turns} turn(s)!`);
    } catch (error) {
        console.error("Error using turns:", error);
        toast.error("Failed to use turns. Please try again.");
    } finally {
        setResourceReceived(false);
        setLoadingTurns(false);
    }
};






    return (

        
        <div
            style={{
                width: '100vw',
                height: '100vh',
                background: 'linear-gradient(to bottom, #87CEFA, #4682B4)',
            }}
        >
            <ToastContainer limit={1} closeButton={false} />
            <div
                id="phaser-container"
                style={{ width: '100%', height: '100%', position: 'relative', zIndex: 0 }}
            />

            <div
  style={{
    pointerEvents: laodingOffensiveTech || loadingDefensiveTech || loadingClanCreate || loadingBlacksmithForge || loadingDefensiveTraining || loadingOffensiveTraining || loadingTurns || loadingArmoryForge ? 'none' : 'auto',
  }}
>


{loading && (
  <>
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(0, 0, 0, 0.7)',
        zIndex: 9999,
        pointerEvents: 'all',
      }}
    ></div>

    <div
      style={{
        position: 'fixed',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        zIndex: 10000,
      }}
    >
      <Circles height="100" width="100" color="#ffffff" ariaLabel="loading-indicator" />
    </div>
  </>
)}

            

         






<div
    id="interaction-menu"
    style={{
        position: 'absolute',
        top: 20,
        left: '50%',
        transform: 'translateX(-50%)',
        display: 'block', // Initially hidden
        zIndex: 200,
        padding: '10px',
        backgroundColor: 'rgba(62, 62, 62, 0.95)',
        borderRadius: '10px',
        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
        border: '2px solid #c4aa70',
        fontFamily: 'EB Garamond, serif',
        color: '#e8dbc0',
    }}
>



{interactionMenuType === "home" && (
    <>
        {tileData && (
    <>
        <div
            style={{
                marginBottom: '10px',
                display: 'flex',
                alignItems: 'center',
                gap: '15px',
                justifyContent: 'center',
            }}
        >
            <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                <img src={foodImage} alt="Food" style={{ width: '20px' }} />
                <span>{tileData.food}</span>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                <img src={woodImage} alt="Wood" style={{ width: '20px' }} />
                <span>{tileData.wood}</span>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                <img src={stoneImage} alt="Stone" style={{ width: '20px' }} />
                <span>{tileData.stone}</span>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                <img src={ironImage} alt="Iron" style={{ width: '20px' }} />
                <span>{tileData.iron}</span>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                <strong>Level:</strong>
                <span>{tileData.level}/500</span>
            </div>
        </div>

        
        <div
                    style={{
                        marginBottom: '10px',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '15px',
                        justifyContent: 'center',
                    }}
                >
                    <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                        <img src={offensiveArmorImage} alt="Offensive Armor" style={{ width: '24px' }} />
                        <span>{tileData.offensiveArmor}</span>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                        <img src={defensiveArmorImage} alt="Defensive Armor" style={{ width: '24px' }} />
                        <span>{tileData.defensiveArmor}</span>
                    </div>


                    <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                        <img src={offensiveWeaponImage} alt="Offensive Weapon" style={{ width: '24px' }} />
                        <span>{tileData.offensiveWeapon}</span>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                        <img src={defensiveWeaponImage} alt="Defensive Weapon" style={{ width: '24px' }} />
                        <span>{tileData.defensiveWeapon}</span>
                    </div>

                    </div>


                    <div
                    style={{
                        marginBottom: '10px',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '15px',
                        justifyContent: 'center',
                    }}
                >

                    <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                <img src={offensiveSoldierImage} alt="Offensive Soldier" style={{ width: '30px' }} />
                <span>{tileData.offensiveSoldier}</span>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                <img src={defensiveSoldierImage} alt="Defensive Soldier" style={{ width: '30px' }} />
                <span>{tileData.defensiveSoldier}</span>
            </div>

            
            <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
    Attack: 
    <span>{tileData ? ((parseInt(tileData.offensiveSoldier) * 2) + parseInt(tileData.defensiveSoldier) + parseInt(tileData.level) + parseInt(tileData.techLevels.offensiveTech)) : 0}</span>
</div>

<div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
    Defense: 
    <span>{tileData ? ((parseInt(tileData.defensiveSoldier) * 2) + parseInt(tileData.offensiveSoldier) + parseInt(tileData.level) + (parseInt(buildingCounts[7] || 0) * 100)  + parseInt(tileData.techLevels.defensiveTech)) : 0}</span>
</div>

            
<div>
        <a
            href={`https://twitter.com`}
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: '#1DA1F2', textDecoration: 'underline', fontSize: '16px' }}
          >
            Realm Docs
          </a>

</div>


                </div>



        {/* Loading Bar */}
        <div className="medieval-progress-bar">
  <div
    className="medieval-progress-fill"
    style={{ width: `${(tileData.accumulatedTurns / 1000) * 100}%` }}
  ></div>
  <div className="medieval-progress-label">
    Next Level {tileData.accumulatedTurns}/{1000}
  </div>


  


</div>

    </>
)}



        <div style={{ marginTop: '10px', display: 'flex', alignItems: 'center', gap: '10px' }}>
       
        {tileData && (
    <>

<div
    style={{
        marginBottom: '10px',
        display: 'flex',
        alignItems: 'center',
        gap: '15px',
        justifyContent: 'center',
    }}
>
    <div style={{ display: 'flex', alignItems: 'center', gap: '5px', cursor: 'pointer' }} 
        onClick={() => fetchTileTurns(tileCoords.x, tileCoords.y)}>
        <img src={turnsImage} alt="Turns" style={{ width: '20px' }} />
        <span>{tileData.turns}/600</span>
    </div>
</div>

        </>
)}

<input
    type="number"
    min="1"
    className="fancy-inputX"
    placeholder="Enter a number"
    style={{ flex: '1' }}
    value={(tileData && tileData.inputTurns) || ""}
    onChange={(e) => {
        const enteredValue = parseInt(e.target.value || "0", 10);
        const maxAllowed = getMaxAllowedTurns();
        const validatedValue = Math.min(enteredValue, maxAllowed); // Ensure the input does not exceed maxAllowed
        setTileData((prev) => ({ ...prev, inputTurns: validatedValue })); // Update input value in state
    }}
/>


<button
    className="card-button"
    onClick={() => {
        const turns = tileData?.inputTurns;
        if (turns && turns > 0) {
            executeUseTurns(turns, tileCoords, toast); // Use the validated value
        } else {
            toast.error("Please enter a valid number of turns");
        }
    }}
>
    Use Turn(s)
</button>



        </div>


{defenderCooldownTurnsLeft !== null && defenderCooldownTurnsLeft > 0 && (
  <div style={{ marginTop: '5px', textAlign: 'center', color: '#ffcc00' }}>
    🛡️ Defender Cooldown: {defenderCooldownTurnsLeft} turn(s) remaining
  </div>
)}


{ResourceReceived && (
<>
<div style={{ marginTop: '15px', textAlign: 'center' }}>
        <p style={{ color: '#52bd2fff' }}><strong>{ResourceReceivedMessage}</strong></p>
</div>
</>
)}


        {pendingInviteClanId && (
    <div style={{ marginTop: '15px', textAlign: 'center' }}>
        <p>You have a pending invite from clan <strong>{pendingInviteClanName}</strong></p>
        <div style={{ display: 'flex', gap: '10px', justifyContent: 'center' }}>
            <button
                onClick={async () => {
   try {
  setLoading(true);

  const clan = await getclanSignerContract();
  const tileMap = await getContract();

  // Connected account
  const accounts = await window.ethereum.request({ method: "eth_accounts" });
  const account = accounts && accounts[0] ? accounts[0] : null;
  if (!account) {
    toast.error("Connect your wallet first.");
    return;
  }

  // Resolve user's tile and verify ownership
  const x = tileCoords.x - 1;
  const y = tileCoords.y - 1;

  const occupant = await tileMap.getTileOccupant(x, y);
  if (!occupant || occupant.toLowerCase() !== account.toLowerCase()) {
    toast.error("You must own your tile to accept the invite.");
    return;
  }

  // Look up the pending invite on this tile
  const tileKey = x * 256 + y; // (x << 8) | y
  const inviteClanIdRaw = await clan.pendingInvitesByTile(tileKey);
  const inviteClanId = parseInt(inviteClanIdRaw);

  if (inviteClanId === 0) {
    toast.info("No pending invite for your tile.");
    await fetchPendingInvite();
    return;
  }

  // Check member count to pick a toast message (contract will auto-clean if full)
  const mcRaw = await clan.getClanMemberCount(inviteClanId);
  const memberCount = parseInt(mcRaw);
  const toastcontent =
    memberCount >= 30 ? "Clan Full, Invitation Removed" : "Joined the Clan";

  // Accept for this tile
  const tx = await clan.acceptInviteForTile(x, y);
  await tx.wait();

  await checkUserClan();
  await fetchPendingInvite();
  toast.info(toastcontent);
} catch (err) {
  console.error("Accept failed:", err);
  await fetchPendingInvite();
} finally {
  setLoading(false);
}

}}

                style={{ padding: '6px 10px', backgroundColor: '#28a745', color: 'white', border: 'none', borderRadius: '5px' }}
            >
                Accept
            </button>
            <button
                onClick={async () => {
                    try {
  setLoading(true);

  const clan = await getclanSignerContract();
  const tileMap = await getContract();

  // Get connected account
  const accounts = await window.ethereum.request({ method: "eth_accounts" });
  const account = accounts && accounts[0] ? accounts[0] : null;
  if (!account) {
    toast.error("Connect your wallet first.");
    return;
  }

  // Resolve the user's tile
  const x = tileCoords.x - 1;
  const y = tileCoords.y - 1;

  // Verify ownership of (x,y)
  const occupant = await tileMap.getTileOccupant(x, y);
  if (!occupant || occupant.toLowerCase() !== account.toLowerCase()) {
    toast.error("You must own your tile to refuse the invite.");
    return;
  }

  // Refuse invite for this tile
  const tx = await clan.refuseInviteForTile(x, y);
  await tx.wait();

  toast.info("Invite refused.");
  setPendingInviteClanId(null);
  setPendingInviteClanName("");
} catch (err) {
  console.error("Refuse failed:", err);
  toast.error("Failed to refuse invite.");
} finally {
  setLoading(false);
}

                }}
                style={{ padding: '6px 10px', backgroundColor: '#dc3545', color: 'white', border: 'none', borderRadius: '5px' }}
            >
                Refuse
            </button>
        </div>
    </div>
)}



        {tileData && tileData.inputTurns > 0 && (
            <>
                <div
                    style={{
                        marginTop: '10px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-around',
                    }}
                >
                    <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                        <img src={foodImage} alt="Food" style={{ width: '20px' }} />
                        <span>+{calculatedResources.food}</span>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                        <img src={woodImage} alt="Wood" style={{ width: '20px' }} />
                        <span>+{calculatedResources.wood}</span>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                        <img src={stoneImage} alt="Stone" style={{ width: '20px' }} />
                        <span>+{calculatedResources.stone}</span>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                        <img src={ironImage} alt="Iron" style={{ width: '20px' }} />
                        <span>+{calculatedResources.iron}</span>
                    </div>
                </div>




<div
            style={{
                marginTop: '10px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-around',
            }}
        >
            <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                <img src={foodImage} alt="Food" style={{ width: '20px' }} />
                <span>
                    {parseInt(tileData.food) + calculatedResources.food}
                </span>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                <img src={woodImage} alt="Wood" style={{ width: '20px' }} />
                <span>
                    {parseInt(tileData.wood) + calculatedResources.wood}
                </span>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                <img src={stoneImage} alt="Stone" style={{ width: '20px' }} />
                <span>
                    {parseInt(tileData.stone) + calculatedResources.stone}
                </span>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                <img src={ironImage} alt="Iron" style={{ width: '20px' }} />
                <span>
                    {parseInt(tileData.iron) + calculatedResources.iron}
                </span>
            </div>
        </div>

        </>
            )}



    </>
)}





















{interactionMenuType === "buildings" && (
    <>
      

        {/* Current Tile Resources */}
        {tileData && (
            <div
                style={{
                    marginBottom: '10px',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '15px',
                    justifyContent: 'center',
                }}
            >
                
                <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                    <img src={foodImage} alt="Food" style={{ width: '20px' }} />
                    <span>{tileData.food}</span>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                    <img src={woodImage} alt="Wood" style={{ width: '20px' }} />
                    <span>{tileData.wood}</span>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                    <img src={stoneImage} alt="Stone" style={{ width: '20px' }} />
                    <span>{tileData.stone}</span>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                    <img src={ironImage} alt="Iron" style={{ width: '20px' }} />
                    <span>{tileData.iron}</span>
                </div>

                <a
            href={`https://twitter.com`}
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: '#1DA1F2', textDecoration: 'underline', fontSize: '11px' }}
          >
            Buildings Docs
          </a>
                
            </div>
        )}

        {/* Building Type List */}
        <div
            style={{
                marginTop: '10px',
                display: 'flex', // Use flex for horizontal alignment
                gap: '6px', // Add space between building cards
                overflowX: 'auto', // Enable horizontal scrolling if needed
                padding: '3px 0',
            }}
        >
           

{/* DESKTOP: the original cards (unchanged) */}
<div className="buildings-desktop">
  <div
    style={{
      marginTop: '10px',
      display: 'flex',
      gap: '6px',
      overflowX: 'auto',
      padding: '3px 0',
    }}
  >
    {buildingTypes.map((building) => (
      <div
        key={building.key}
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: '6px',
          padding: '3px',
          border: `2px solid ${selectedBuilding === building.image ? '#daccb0ff' : '#c4aa70'}`,
          borderRadius: '10px',
          cursor: 'pointer',
          backgroundColor: selectedBuilding === building.image ? '#575757ff' : '#3e3e3e',
          minWidth: '120px',
        }}
        onClick={() => handleSelectBuilding(building)}
      >
        <img
          src={require(`./assets/buildings/${building.image}.png`)}
          alt={building.label}
          style={{ width: '60px', height: '60px' }}
        />
        {building.label}({buildingCounts[building.no] || 0})
        <div style={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '2px' }}>
            <img src={foodImage} alt="Food" style={{ width: '20px' }} />
            <span>{building.cost.food}</span>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '2px' }}>
            <img src={woodImage} alt="Wood" style={{ width: '20px' }} />
            <span>{building.cost.wood}</span>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '2px' }}>
            <img src={stoneImage} alt="Stone" style={{ width: '20px' }} />
            <span>{building.cost.stone}</span>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '2px' }}>
            <img src={ironImage} alt="Iron" style={{ width: '20px' }} />
            <span>{building.cost.iron}</span>
          </div>
        </div>
      </div>
    ))}
  </div>
</div>

{/* MOBILE: a compact lined table */}
<div className="buildings-mobile">
  <table className="buildings-table">
    <thead>
      <tr>
        <th>Building</th>
        <th>Req. Food</th>
        <th>Req. Wood</th>
        <th>Req. Stone</th>
        <th>Req. Iron</th>
        <th>Do</th>
      </tr>
    </thead>
    <tbody>
      {buildingTypes.map((b) => (
        <tr key={b.key}>
          <td className="bcell-name">
            <div className="bcell-name__wrap">
              <img
                src={require(`./assets/buildings/${b.image}.png`)}
                alt={b.label}
                className="bimg"
              />
              <div className="btitle">
                {b.label} ({buildingCounts[b.no] || 0})
              </div>
            </div>
          </td>
          <td>{b.cost.food}</td>
          <td>{b.cost.wood}</td>
          <td>{b.cost.stone}</td>
          <td>{b.cost.iron}</td>
          <td>
            <button
              className="card-button bselect"
              onClick={() => handleSelectBuilding(b)}
            >
              Select
            </button>
          </td>
        </tr>
      ))}
    </tbody>
  </table>
</div>

        </div>
    </>
)}



{interactionMenuType === "armory" && (
  <div>

    <div style={{ display: 'flex', justifyContent: 'center', marginTop: '10px' }}>
  <button
    style={{ backgroundColor: '#3b0000ff', marginBottom: '10px', color: 'gray' }}
    onClick={() => demolishBuilding(selectedInteriorCoords.x, selectedInteriorCoords.y)}
  >
    Demolish This Building
  </button>
</div>


    <div className="card-title">Produce Armor</div>

   



    {tileData && (
        <>
      <div className="card-resource-bar">
        <div className="resource-item">
          <img src={foodImage} alt="Food" style={{ width: "20px" }} />
          <span>{tileData.food}</span>
        </div>
        <div className="resource-item">
          <img src={woodImage} alt="Wood" style={{ width: "20px" }} />
          <span>{tileData.wood}</span>
        </div>
        <div className="resource-item">
          <img src={stoneImage} alt="Stone" style={{ width: "20px" }} />
          <span>{tileData.stone}</span>
        </div>
        <div className="resource-item">
          <img src={ironImage} alt="Iron" style={{ width: "20px" }} />
          <span>{tileData.iron}</span>
        </div>

        
      </div>

<div
style={{
    marginBottom: '10px',
    display: 'flex',
    alignItems: 'center',
    gap: '15px',
    justifyContent: 'center',
}}
>
<div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
    <img src={offensiveArmorImage} alt="Offensive Armor" style={{ width: '20px' }} />
    <span>{tileData.offensiveArmor}</span>
</div>
<div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
    <img src={defensiveArmorImage} alt="Defensive Armor" style={{ width: '20px' }} />
    <span>{tileData.defensiveArmor}</span>
</div>


<div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
    <img src={offensiveWeaponImage} alt="Offensive Weapon" style={{ width: '20px' }} />
    <span>{tileData.offensiveWeapon}</span>
</div>
<div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
    <img src={defensiveWeaponImage} alt="Defensive Weapon" style={{ width: '20px' }} />
    <span>{tileData.defensiveWeapon}</span>
</div>


<div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                <img src={offensiveSoldierImage} alt="Offensive Soldier" style={{ width: '20px' }} />
                <span>{tileData.offensiveSoldier}</span>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                <img src={defensiveSoldierImage} alt="Defensive Soldier" style={{ width: '20px' }} />
                <span>{tileData.defensiveSoldier}</span>
            </div>


</div>

</>
    )}
    <div className="card-content">
    <div className="input-container">
        <img src={offensiveArmorImage} alt="Offensive" style={{ width: "50px" }} />
        <input
            type="number"
            min="0"
            value={armorQuantities.offensive}
            onChange={(e) => handleArmorInputChange(1, e.target.value)}
        />
        <button
            className="card-button"
            onClick={() => produceArmor(1, armorQuantities.offensive)}
        >
            Produce Offensive Armor
        </button>
    </div>
    <div className="input-container">
        <img src={defensiveArmorImage} alt="Defensive" style={{ width: "50px" }} />
        <input
            type="number"
            min="0"
            value={armorQuantities.defensive}
            onChange={(e) => handleArmorInputChange(2, e.target.value)}
        />
        <button
            className="card-button"
            onClick={() => produceArmor(2, armorQuantities.defensive)}
        >
            Produce Defensive Armor
        </button>
    </div>

    {showArmorCosts && (
        <>
    <div
        style={{
            marginTop: '10px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '15px',
        }}
    >
        <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
            <img src={foodImage} alt="Food" style={{ width: '20px' }} />
            <span>-{armorCosts.food}</span>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
            <img src={woodImage} alt="Wood" style={{ width: '20px' }} />
            <span>-{armorCosts.wood}</span>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
            <img src={stoneImage} alt="Stone" style={{ width: '20px' }} />
            <span>-{armorCosts.stone}</span>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
            <img src={ironImage} alt="Iron" style={{ width: '20px' }} />
            <span>-{armorCosts.iron}</span>
        </div>
    </div>

<div
style={{
    marginTop: '10px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '15px',
}}
>
<div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
    <img src={foodImage} alt="Food" style={{ width: '20px' }} />
    
    <span>{parseInt(tileData.food) - armorCosts.food}</span>
</div>
<div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
    <img src={woodImage} alt="Wood" style={{ width: '20px' }} />
    <span>{parseInt(tileData.wood) - armorCosts.wood}</span>
</div>
<div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
    <img src={stoneImage} alt="Stone" style={{ width: '20px' }} />
    <span>{parseInt(tileData.stone) - armorCosts.stone}</span>
</div>
<div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
    <img src={ironImage} alt="Iron" style={{ width: '20px' }} />
    <span>{parseInt(tileData.iron) - armorCosts.iron}</span>
</div>
</div>

</>
)}

</div>


  </div>
)}






{interactionMenuType === "blacksmith" && (
  <div>
    <div style={{ display: 'flex', justifyContent: 'center', marginTop: '10px' }}>
  <button
    style={{ backgroundColor: '#3b0000ff', marginBottom: '10px', color: 'gray' }}
    onClick={() => demolishBuilding(selectedInteriorCoords.x, selectedInteriorCoords.y)}
  >
    Demolish This Building
  </button>
</div>
    <div className="card-title">Produce Weapon</div>
    {tileData && (
        <>
      <div className="card-resource-bar">
        <div className="resource-item">
          <img src={foodImage} alt="Food" style={{ width: "20px" }} />
          <span>{tileData.food}</span>
        </div>
        <div className="resource-item">
          <img src={woodImage} alt="Wood" style={{ width: "20px" }} />
          <span>{tileData.wood}</span>
        </div>
        <div className="resource-item">
          <img src={stoneImage} alt="Stone" style={{ width: "20px" }} />
          <span>{tileData.stone}</span>
        </div>
        <div className="resource-item">
          <img src={ironImage} alt="Iron" style={{ width: "20px" }} />
          <span>{tileData.iron}</span>
        </div>

        
      </div>

<div
style={{
    marginBottom: '10px',
    display: 'flex',
    alignItems: 'center',
    gap: '15px',
    justifyContent: 'center',
}}
>
<div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
    <img src={offensiveArmorImage} alt="Offensive Armor" style={{ width: '20px' }} />
    <span>{tileData.offensiveArmor}</span>
</div>
<div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
    <img src={defensiveArmorImage} alt="Defensive Armor" style={{ width: '20px' }} />
    <span>{tileData.defensiveArmor}</span>
</div>

<div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
    <img src={offensiveWeaponImage} alt="Offensive Armor" style={{ width: '20px' }} />
    <span>{tileData.offensiveWeapon}</span>
</div>
<div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
    <img src={defensiveWeaponImage} alt="Defensive Armor" style={{ width: '20px' }} />
    <span>{tileData.defensiveWeapon}</span>
</div>

<div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                <img src={offensiveSoldierImage} alt="Offensive Soldier" style={{ width: '20px' }} />
                <span>{tileData.offensiveSoldier}</span>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                <img src={defensiveSoldierImage} alt="Defensive Soldier" style={{ width: '20px' }} />
                <span>{tileData.defensiveSoldier}</span>
            </div>

</div>

</>
    )}
    <div className="card-content">
    <div className="input-container">
        <img src={offensiveWeaponImage} alt="Offensive" style={{ width: "50px" }} />
        <input
            type="number"
            min="0"
            value={weaponQuantities.offensive}
            onChange={(e) => handleWeaponInputChange(1, e.target.value)}
        />
        <button
            className="card-button"
            onClick={() => produceWeapon(1, weaponQuantities.offensive)}
        >
            Produce Offensive Weapon
        </button>
    </div>
    <div className="input-container">
        <img src={defensiveWeaponImage} alt="Defensive" style={{ width: "50px" }} />
        <input
            type="number"
            min="0"
            value={weaponQuantities.defensive}
            onChange={(e) => handleWeaponInputChange(2, e.target.value)}
        />
        <button
            className="card-button"
            onClick={() => produceWeapon(2, weaponQuantities.defensive)}
        >
            Produce Defensive Weapon
        </button>
    </div>

    {showWeaponCosts && (
        <>
    <div
        style={{
            marginTop: '10px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '15px',
        }}
    >
        <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
            <img src={foodImage} alt="Food" style={{ width: '20px' }} />
            <span>-{weaponCosts.food}</span>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
            <img src={woodImage} alt="Wood" style={{ width: '20px' }} />
            <span>-{weaponCosts.wood}</span>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
            <img src={stoneImage} alt="Stone" style={{ width: '20px' }} />
            <span>-{weaponCosts.stone}</span>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
            <img src={ironImage} alt="Iron" style={{ width: '20px' }} />
            <span>-{weaponCosts.iron}</span>
        </div>
    </div>

<div
style={{
    marginTop: '10px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '15px',
}}
>
<div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
    <img src={foodImage} alt="Food" style={{ width: '20px' }} />
    
    <span>{parseInt(tileData.food) - weaponCosts.food}</span>
</div>
<div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
    <img src={woodImage} alt="Wood" style={{ width: '20px' }} />
    <span>{parseInt(tileData.wood) - weaponCosts.wood}</span>
</div>
<div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
    <img src={stoneImage} alt="Stone" style={{ width: '20px' }} />
    <span>{parseInt(tileData.stone) - weaponCosts.stone}</span>
</div>
<div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
    <img src={ironImage} alt="Iron" style={{ width: '20px' }} />
    <span>{parseInt(tileData.iron) - weaponCosts.iron}</span>
</div>
</div>

</>
)}

</div>


  </div>
)}



{interactionMenuType === "train-soldier" && (
  <div>
    <div style={{ display: 'flex', justifyContent: 'center', marginTop: '10px' }}>
  <button
    style={{ backgroundColor: '#3b0000ff', marginBottom: '10px', color: 'gray' }}
    onClick={() => demolishBuilding(selectedInteriorCoords.x, selectedInteriorCoords.y)}
  >
    Demolish This Building
  </button>
</div>
    <div className="card-title">Train Soldiers</div>
    {tileData && (
        <>
          <div className="card-resource-bar">
            <div className="resource-item">
              <img src={foodImage} alt="Food" style={{ width: "20px" }} />
              <span>{tileData.food}</span>
            </div>
            <div className="resource-item">
              <img src={woodImage} alt="Wood" style={{ width: "20px" }} />
              <span>{tileData.wood}</span>
            </div>
            <div className="resource-item">
              <img src={stoneImage} alt="Stone" style={{ width: "20px" }} />
              <span>{tileData.stone}</span>
            </div>
            <div className="resource-item">
              <img src={ironImage} alt="Iron" style={{ width: "20px" }} />
              <span>{tileData.iron}</span>
            </div>
          </div>

          <div
            style={{
                marginBottom: '10px',
                display: 'flex',
                alignItems: 'center',
                gap: '15px',
                justifyContent: 'center',
            }}
          >

<div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
    <img src={offensiveArmorImage} alt="Offensive Armor" style={{ width: '20px' }} />
    <span>{tileData.offensiveArmor}</span>
</div>
<div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
    <img src={defensiveArmorImage} alt="Defensive Armor" style={{ width: '20px' }} />
    <span>{tileData.defensiveArmor}</span>
</div>

<div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
    <img src={offensiveWeaponImage} alt="Offensive Armor" style={{ width: '20px' }} />
    <span>{tileData.offensiveWeapon}</span>
</div>
<div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
    <img src={defensiveWeaponImage} alt="Defensive Armor" style={{ width: '20px' }} />
    <span>{tileData.defensiveWeapon}</span>
</div>


            <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                <img src={offensiveSoldierImage} alt="Offensive Soldier" style={{ width: '20px' }} />
                <span>{tileData.offensiveSoldier}</span>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                <img src={defensiveSoldierImage} alt="Defensive Soldier" style={{ width: '20px' }} />
                <span>{tileData.defensiveSoldier}</span>
            </div>
          </div>
        </>
    )}

    <div className="card-content">
      <div className="input-container">
          <img src={offensiveSoldierImage} alt="Offensive Soldier" style={{ width: "50px" }} />
          <input
              type="number"
              min="0"
              value={soldierQuantities.offensive}
              onChange={(e) => handleSoldierInputChange(1, e.target.value)}
          />
          <button
    className="card-button"
    onClick={() => trainSoldier(1, soldierQuantities.offensive)}
>
    Train Offensive Soldier
</button>
      </div>

      <div className="input-container">
          <img src={defensiveSoldierImage} alt="Defensive Soldier" style={{ width: "50px" }} />
          <input
              type="number"
              min="0"
              value={soldierQuantities.defensive}
              onChange={(e) => handleSoldierInputChange(2, e.target.value)}
          />
          <button
    className="card-button"
    onClick={() => trainSoldier(2, soldierQuantities.defensive)}
>
    Train Defensive Soldier
</button>
      </div>




      {showSoldierCosts && (
        <>
    <div
        style={{
            marginTop: '10px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '15px',
        }}
    >
        <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
            <img src={foodImage} alt="Food" style={{ width: '20px' }} />
            <span>-{soldierCosts.food}</span>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
            <img src={woodImage} alt="Wood" style={{ width: '20px' }} />
            <span>-{soldierCosts.wood}</span>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
            <img src={stoneImage} alt="Stone" style={{ width: '20px' }} />
            <span>-{soldierCosts.stone}</span>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
            <img src={ironImage} alt="Iron" style={{ width: '20px' }} />
            <span>-{soldierCosts.iron}</span>
        </div>
    </div>

<div
style={{
    marginTop: '10px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '15px',
}}
>
<div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
    <img src={foodImage} alt="Food" style={{ width: '20px' }} />
    
    <span>{parseInt(tileData.food) - soldierCosts.food}</span>
</div>
<div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
    <img src={woodImage} alt="Wood" style={{ width: '20px' }} />
    <span>{parseInt(tileData.wood) - soldierCosts.wood}</span>
</div>
<div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
    <img src={stoneImage} alt="Stone" style={{ width: '20px' }} />
    <span>{parseInt(tileData.stone) - soldierCosts.stone}</span>
</div>
<div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
    <img src={ironImage} alt="Iron" style={{ width: '20px' }} />
    <span>{parseInt(tileData.iron) - soldierCosts.iron}</span>
</div>
</div>

</>
)}




    </div>
  </div>
)}




{interactionMenuType === "house-info" && (
    <div>
        <div style={{ display: 'flex', justifyContent: 'center', marginTop: '10px' }}>
  <button
    style={{ backgroundColor: '#3b0000ff', marginBottom: '10px', color: 'gray' }}
    onClick={() => demolishBuilding(selectedInteriorCoords.x, selectedInteriorCoords.y)}
  >
    Demolish This Building
  </button>
</div>
    <div className="card-title">House</div>
    {tileData && (
        <>
          <div className="card-resource-bar">
          House is providing +1 to all resources each turn
          </div>

          
        </>
    )}

  
  </div>
)}




{interactionMenuType === "tower-info" && (
    <div>
        <div style={{ display: 'flex', justifyContent: 'center', marginTop: '10px' }}>
  <button
    style={{ backgroundColor: '#3b0000ff', marginBottom: '10px', color: 'gray' }}
    onClick={() => demolishBuilding(selectedInteriorCoords.x, selectedInteriorCoords.y)}
  >
    Demolish This Building
  </button>
</div>
    <div className="card-title">Tower</div>
    {tileData && (
        <>
          <div className="card-resource-bar">
          Tower is providing +100 to Realm's Defense Power
          </div>

          
        </>
    )}

  
  </div>
)}




{interactionMenuType === "workshop" && (
    <div>
        <div style={{ display: 'flex', justifyContent: 'center', marginTop: '10px' }}>
  <button
    style={{ backgroundColor: '#3b0000ff', marginBottom: '10px', color: 'gray' }}
    onClick={() => demolishBuilding(selectedInteriorCoords.x, selectedInteriorCoords.y)}
  >
    Demolish This Building
  </button>
</div>
        <div className="card-title">Workshop</div>

        {tileData && (
            <>
                <div className="card-resource-bar">
                    <div className="resource-item">
                        <img src={foodImage} alt="Food" style={{ width: "20px" }} />
                        <span>{tileData.food}</span>
                    </div>
                    <div className="resource-item">
                        <img src={woodImage} alt="Wood" style={{ width: "20px" }} />
                        <span>{tileData.wood}</span>
                    </div>
                    <div className="resource-item">
                        <img src={stoneImage} alt="Stone" style={{ width: "20px" }} />
                        <span>{tileData.stone}</span>
                    </div>
                    <div className="resource-item">
                        <img src={ironImage} alt="Iron" style={{ width: "20px" }} />
                        <span>{tileData.iron}</span>
                    </div>
                </div>

                <div className="card-content">
                    {[
                        { id: 1, name: "Offensive Tech", level: tileData.techLevels.offensiveTech },
                        { id: 2, name: "Defensive Tech", level: tileData.techLevels.defensiveTech }
                    ].map((tech) => {
                        // Calculate upgrade costs dynamically
                        const workshopCount = buildingCounts[8] || 1; // Ensure at least 1 workshop exists
                        const costMultiplier = (parseInt(tech.level) + 1) * 2;
                        const foodCost = Math.ceil((140 * costMultiplier) / workshopCount);
                        const woodCost = Math.ceil((120 * costMultiplier) / workshopCount);
                        const stoneCost = Math.ceil((180 * costMultiplier) / workshopCount);
                        const ironCost = Math.ceil((120 * costMultiplier) / workshopCount);

                        return (
                            <div className="tech-item" key={tech.id}>
                                <strong>{tech.name}:</strong> {tech.level} / 10000 &nbsp;
                                <button className='card-button' style={{ marginleft: '15px', marginTop: '15px' }} onClick={() => upgradeTech(tech.id)}>Upgrade</button>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                    <img src={foodImage} alt="Food" style={{ width: '20px' }} />
                                    <span>{foodCost}</span>
                                    <img src={woodImage} alt="Wood" style={{ width: '20px' }} />
                                    <span>{woodCost}</span>
                                    <img src={stoneImage} alt="Stone" style={{ width: '20px' }} />
                                    <span>{stoneCost}</span>
                                    <img src={ironImage} alt="Iron" style={{ width: '20px' }} />
                                    <span>{ironCost}</span>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </>
        )}
    </div>
)}




{interactionMenuType === "marketplace" && (
    <div>
        <div style={{ display: 'flex', justifyContent: 'center', marginTop: '10px' }}>
  <button
    style={{ backgroundColor: '#3b0000ff', marginBottom: '10px', color: 'gray' }}
    onClick={() => demolishBuilding(selectedInteriorCoords.x, selectedInteriorCoords.y)}
  >
    Demolish This Building
  </button>
</div>
        <div className="card-title">Marketplace</div>

        {/* Resource Selection */}
        <div className="card-content">
            <h4>Select a Resource Type</h4>
            <select 
            className="medieval-select"
                value={selectedResourceType} 
                onChange={(e) => setSelectedResourceType(e.target.value)}
            >
                <option value="1">Food</option>
                <option value="2">Wood</option>
                <option value="3">Stone</option>
                <option value="4">Iron</option>
                <option value="5">Offensive Armor</option>
                <option value="6">Defensive Armor</option>
                <option value="7">Offensive Weapon</option>
                <option value="8">Defensive Weapon</option>
            </select>
            <button 
                onClick={fetchMarketplaceItemsByType} 
                className='card-button'
                style={{ marginTop: '10px', padding: '8px' }}
            >
                Show Listings
            </button>
        </div>

        {/* List of Items (Only shows after fetching) */}
        {marketplaceItems.length > 0 ? (
            <div className="marketplace-list">
                <h4>Listed Items</h4>
                {marketplaceItems.map((item, index) => (
                    <div key={index} className="market-item" 
                        style={{
                            display: 'flex', 
                            alignItems: 'center', 
                            justifyContent: 'space-between',
                            padding: '5px 10px', 
                            borderBottom: '1px solid #ddd'
                        }}>
                        <span style={{ paddingLeft: '10px', paddingRight: '10px' }}><strong>{item.sellerX}, {item.sellerY}</strong></span>
                        <span style={{ paddingLeft: '10px', paddingRight: '10px' }}>Item: {item.resourceTypeX}</span>
                        <span style={{ paddingLeft: '10px', paddingRight: '10px' }}>Amount: {item.amount}</span>
                        <span style={{ paddingLeft: '10px', paddingRight: '10px' }}>Price: {item.price / (10 ** 6)} LOP</span>
                        <button 
                            style={{
                                padding: '5px 10px', 
                                backgroundColor: '#28a745', 
                                color: 'white', 
                                border: 'none', 
                                borderRadius: '5px', 
                                cursor: 'pointer'
                            }}
                            onClick={() => buyItem(item, index)}
                        >
                            Buy
                        </button>


                        {item.isOwnListing && (
          <button
            style={{
              padding: '5px 10px',
              backgroundColor: '#dc3545',
              color: 'white',
              border: 'none',
              borderRadius: '5px',
              cursor: 'pointer'
            }}
            onClick={() => cancelListing(item, index)}
          >
            Remove (10000 LOP Tokens)
          </button>
        )}



                    </div>
                ))}
            </div>
        ) : (
            <p style={{ marginTop: '10px' }}>No items found in this category.</p>
        )}

        {/* Button to List a New Item */}
        <button 
            onClick={() => setinteractionMenuType("marketplaceCreate")}
            className='card-button'
            style={{ marginTop: '10px', padding: '8px', width: '100%' }}
        >
            List an Item for Sale
        </button>
    </div>
)}








{interactionMenuType === "marketplaceCreate" && (
    <div>
        <div className="card-title">Marketplace</div>

        {tileData && (
            <>
                <div className="card-resource-bar">
                    <div className="resource-item">
                        <img src={foodImage} alt="Food" style={{ width: "20px" }} />
                        <span>{tileData.food}</span>
                    </div>
                    <div className="resource-item">
                        <img src={woodImage} alt="Wood" style={{ width: "20px" }} />
                        <span>{tileData.wood}</span>
                    </div>
                    <div className="resource-item">
                        <img src={stoneImage} alt="Stone" style={{ width: "20px" }} />
                        <span>{tileData.stone}</span>
                    </div>
                    <div className="resource-item">
                        <img src={ironImage} alt="Iron" style={{ width: "20px" }} />
                        <span>{tileData.iron}</span>
                    </div>
                </div>

<div
            style={{
                marginBottom: '10px',
                display: 'flex',
                alignItems: 'center',
                gap: '15px',
                justifyContent: 'center',
            }}
          >

          
                <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
    <img src={offensiveArmorImage} alt="Offensive Armor" style={{ width: '20px' }} />
    <span>{tileData.offensiveArmor}</span>
</div>
<div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
    <img src={defensiveArmorImage} alt="Defensive Armor" style={{ width: '20px' }} />
    <span>{tileData.defensiveArmor}</span>
</div>

<div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
    <img src={offensiveWeaponImage} alt="Offensive Armor" style={{ width: '20px' }} />
    <span>{tileData.offensiveWeapon}</span>
</div>
<div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
    <img src={defensiveWeaponImage} alt="Defensive Armor" style={{ width: '20px' }} />
    <span>{tileData.defensiveWeapon}</span>
</div>


</div>

                <div className="card-content">
                    <div style={{ fontWeight: '900' }}>List an Item for Sale</div>
                    <div>min:10.000 for resources - min:100 for equipments</div>
                    <div>min price: 10 LOP ( Maximum 5 Listings )</div>
                    <select className="medieval-select" value={selectedResource} onChange={(e) => setSelectedResource(e.target.value)}>
    <option value="1">Food</option>
    <option value="2">Wood</option>
    <option value="3">Stone</option>
    <option value="4">Iron</option>
    <option value="5">Offensive Armor</option>
    <option value="6">Defensive Armor</option>
    <option value="7">Offensive Weapon</option>
    <option value="8">Defensive Weapon</option>
</select>
<input 
    className='fancy-input'
    type="number" 
    placeholder="Amount" 
    value={sellAmount} 
    onChange={(e) => setSellAmount(e.target.value)} 
/>

<input 
className='fancy-input'
    type="number" 
    placeholder="Price in LOP" 
    value={sellPrice} 
    onChange={(e) => setSellPrice(e.target.value)} 
/>
<div>%10 will be added on top your price for burn mechanism</div>
                    <button className='card-button' onClick={() => listItemForSale()}>
                        List Item for Sale
                    </button>
                </div>
            </>
        )}
    </div>
)}




{interactionMenuType === "clanhall" && (
    <div className="interaction-menu" style={{ minWidth: '300px' }}>

        <div style={{ display: 'flex', justifyContent: 'center', marginTop: '10px' }}>
  <button
    style={{ backgroundColor: '#3b0000ff', color: 'gray' }}
    onClick={() => demolishBuilding(selectedInteriorCoords.x, selectedInteriorCoords.y)}
  >
    Demolish This Building
  </button>
</div>


        <h4>Clan Hall</h4>
        {userClan ? (
            <div>
                <p><strong>Clan:</strong> {clanDetails?.name}</p>
                <p><strong>Leader:</strong> {clanDetails?.leaderX}, {clanDetails?.leaderY}</p>
                <p><strong>Members:</strong> {parseInt(clanDetails?.memberCount)}/30</p>

            {showFlagSelector && (
  <div className="interaction-menuA" style={{ minWidth: '900px', maxHeight: '500px', overflowY: 'auto' }}>
    <div>Select an NFT as your Clan Flag</div>
    <div style={{ marginBottom: '10px'}}>Setting a new flag requires 10.000 LOP tokens</div>
    <button className="card-button" onClick={() => setShowFlagSelector(false)}>Cancel</button>
    <div style={{ marginTop: '10px', display: 'flex', flexWrap: 'wrap', gap: '10px' }}>


        {ownedFlagNFTs.length === 0 && (
            <>
            <div style={{
      marginTop: '20px',
      display: 'flex',
      justifyContent: 'center', // horizontally center
      alignItems: 'center',     // vertically center (optional)
      width: '100%',
      textAlign: 'center',
    }}>No NFTS found from Kilopi NFT Marketplace Collection ID:1
    

   

    
    </div>


     <a
  href={'https://kilopi.net/nftmarket/'}
  target="_blank"
  rel="noopener noreferrer"
  style={{
    marginBottom: '20px',
      display: 'flex',
      justifyContent: 'center', // horizontally center
      alignItems: 'center',     // vertically center (optional)
      width: '100%',
      textAlign: 'center',
      color: 'cyan'
  }}
>
  Go to Kilopi NFT Marketplace
</a>
</>
        )}

      {ownedFlagNFTs.map(nft => (
        <div key={nft.tokenId} style={{ border: '1px solid #ccc', padding: '5px' }}>
          <img src={nft.imageUrl} alt="nft" width={300} height={300} />
          <button className="card-button" onClick={() => handleSetClanFlag(nft.tokenId)}>
            Set as Flag
          </button>
        </div>
      ))}
    </div>
  </div>
)}




                {clanDetails?.isLeader && (
<>
<div>
                    <button className="card-button" onClick={() => fetchFlagNFTs()}>
    Set Clan Flag
  </button>
</div>
                    <button 
                        onClick={handleDisbandClan}
                        style={{
                            marginTop: '10px',
                            marginBottom: '10px',
                            padding: '10px',
                            backgroundColor: '#dc3545',
                            color: 'white',
                            border: 'none',
                            borderRadius: '5px',
                            cursor: 'pointer'
                        }}
                    >
                        Disband Clan
                    </button>
                    </>
                )}
            </div>
        ) : (
            <div>
                <input
                    type="text"
                    placeholder="Enter clan name"
                    value={newClanName}
                    onChange={(e) => setNewClanName(e.target.value)}
                    className='fancy-input'
                    style={{
                        marginBottom: '10px',
                        padding: '8px',
                        borderRadius: '5px',
                    }}
                />
                <button
                    onClick={createClan}
                    disabled={loading}
                    className='card-button'
                    style={{
                        marginBottom: '10px'
                    }}
                >
                    {loading ? "Creating Clan..." : "Create Clan ( 100.000 LOP )"}
                </button>

            </div>
        )}

        {/* Show this button for both cases */}
        <button
    className="card-button"
    onClick={fetchAllClans}
>
    List All Clans
</button>

    </div>
)}







{showAllClansModal && (
    <div
        style={{
            position: 'fixed',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            backgroundColor: '#2b2b2b',
            padding: '20px',
            borderRadius: '10px',
            zIndex: 999,
            width: '420px',
            maxHeight: '400px',
            overflowY: 'auto',
            boxShadow: '0 4px 8px rgba(0,0,0,0.2)',
        }}
    >
        <h4 style={{ textAlign: 'center' }}>All Clans</h4>

        {allClans.length > 0 ? (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
        {/* Header Row */}
        <div
            style={{
                display: 'flex',
                fontWeight: 'bold',
                borderBottom: '1px solid #ccc',
                paddingBottom: '6px',
            }}
        >
            <div style={{ flex: 1, textAlign: 'center' }}>Name</div>
            <div style={{ flex: 1, textAlign: 'center' }}>Leader</div>
            <div style={{ flex: 1, textAlign: 'center' }}>Members</div>
        </div>

        {/* Clan Rows */}
        {allClans.map((clan, index) => (
            <div
                key={index}
                style={{
                    display: 'flex',
                    borderBottom: '1px solid #eee',
                    padding: '4px 0',
                    fontSize: '14px',
                }}
            >
                <div style={{ flex: 1, textAlign: 'center'}}>{clan.name}</div>
                <div style={{ flex: 1, textAlign: 'center' }}>{parseInt(clan?.leaderX) + 1}, {parseInt(clan?.leaderY) + 1}</div>
                <div style={{ flex: 1, textAlign: 'center' }}>{parseInt(clan.memberCount)}/30</div>
            </div>
        ))}
    </div>
) : (
    <p>No clans found.</p>
)}


        <button
            onClick={() => setShowAllClansModal(false)}
            style={{
                width: '100%',
                marginTop: '15px'
            }}
            className='card-button'
        >
            Close
        </button>
    </div>
)}







</div>




      
      <button
  onClick={toggleMusic}
  style={{
    position: 'absolute',
    top: 10,
    right: 10,
    padding: '10px',
    backgroundColor: 'transparent',
    border: 'none',
    cursor: 'pointer',
    zIndex: 101,
  }}
>
  <img
    src={isMusicPlaying ? stopIcon : playIcon}
    alt={isMusicPlaying ? 'Stop Music' : 'Play Music'}
    style={{ width: '24px', height: '24px' }}
  />
</button>



      




            <div
                className="message-cardT"
                style={{
                    position: 'absolute',
                    top: 10,
                    left: 1,
                    padding: '6px',
                    backgroundColor: 'rgba(62, 62, 62, 0.95)',
                    borderRadius: '10px',
                    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
                    zIndex: 100,
                    width: '250px',
                    color: '#e0d8c3',
                }}
            >
                <button
          onClick={() => window.location.reload()}
          className="info-box-button"
        >
          Back to Map
        </button>
                {metaMaskAccount ? (
                    <p>
                        <strong>Logged in:</strong>{' '}
                        {`${metaMaskAccount.slice(0, 4)}...${metaMaskAccount.slice(-3)}`}
                    </p>
                ) : (
                    <button type="button" onClick={loginMetaMask}>
                        Connect
                    </button>
                )}
                {tileCoords && (
        <>
            <p>
                <strong>Land:</strong> <br/> X: {tileCoords.x}, Y: {tileCoords.y}
            </p>


                <p>
                    <strong>Bonus:</strong> {tileCoords.bonusType}
                </p>





            {tileName ? (
    <>
        <strong>Realm Name:</strong> {tileName}
    </>
) : (

<>
        Realm has no Name
    </>


)}







            {metaMaskAccount && (
    <>
        <button
            style={{
                marginTop: '10px',
                padding: '6px',
                backgroundColor: '#7a5e3c',
                color: '#f3eacb',
                border: '1px solid #c4aa70',
                borderRadius: '5px',
                cursor: 'pointer',
                width: '100%',
                fontWeight: 'bold',
            }}
            onClick={() => setShowNameInput(prev => !prev)}

        >
            Rename Realm
        </button>

        {showNameInput && (
            <div style={{ marginTop: '10px' }}>
                <input
                    type="text"
                    placeholder="Enter Realm Name (10.000 LOP)"
                    value={tileNameInput}
                    onChange={(e) => setTileNameInput(e.target.value)}
                    style={{
                        backgroundColor: '#2b2b2b',
                        width: '90%',
                        padding: '6px',
                        borderRadius: '5px',
                        border: '1px solid #a88f58',
                        marginBottom: '8px',
                        fontSize: '14px',
                        color: '#e8dbc0'
                    }}
                />
                <button
                    onClick={handleNameTile}
                    style={{
                padding: '8px',
                backgroundColor: '#7a5e3c',
                color: '#f3eacb',
                border: '1px solid #c4aa70',
                borderRadius: '5px',
                cursor: 'pointer',
                width: '100%',
                fontWeight: 'bold',
                    }}
                >
                    Submit
                </button>
            </div>
        )}
    </>
)}








            
        </>
    )}
            </div>
            </div>
        </div>
    );
};

export default TheLand;
